<template>
    <!-- 列表 -->
    <div :class="['live_item', 'appLiveList' + msg.id, 'appLiveList_' + pageName, {
            is_order: msg.state2 === 'top'? true: false
        }]" :data-index="indexItem"
        v-if="((sourcePage == 'jf' && msg.kind == 'vip') || (sourcePage != 'jf')) && msg.kind != 'robot'"
    >

        <!-- 仅自己可见 -->
        <div
            class="is_only_self_show"
            v-if="msg.only_self_show === 'yes' && u_id == msg.u_id"
            @click.stop.prevent="handleClickToLiveDetail"
        >仅自己可见</div>
        
        <!-- 仅粉丝可见 -->
        <div
            class="is_only_fans_show"
            v-if="msg.is_fans_show == '1'"
            @click.stop.prevent="handleClickToLiveDetail"
        >仅粉丝可见</div>

        <!-- 仅会员可见 -->
        <div
            class="is_only_vip_show"
            v-if=" (msg.not_vip_show == 'no' && msg.vip_show == 'yes' && msg.unshow_group.length == 0)"
            @click.stop.prevent="handleClickToLiveDetail"
        >仅会员可见</div>

        <!-- 机器人诊股 -->
        <template v-if="msg.kind == 'robot' && msg && msg.robot && msg.robot.length > 0">
            <div class="live_robot">
                <div class="live_robot_wrap">
                    <div class="live_robot_content">
                        <p><span @click.stop.prevent="openNative('robot_page', {
                            title: msg.robot[0].title,
                            o_kind: msg.robot[0].kind,
                            user_stock: ''
                        })">@{{msg.robot[0].title}}</span>{{msg.robot[0].content}}</p>
                    </div>

                    <div class="live_robot_main" @click.stop.prevent="openNative('robot_page', {
                        title: msg.robot[0].title,
                        o_kind: msg.robot[0].kind,
                        user_stock: msg.robot[0].user_stock
                    })">
                        <div class="live_robot_avatar">
                            <img :src="msg.robot[0].image" alt="">
                        </div>
                        <div class="live_robot_brief">
                            <p>{{msg.robot[0].logo_title}}</p>
                        </div>
                        <div class="live_robot_num">{{msg.robot[0].nums_see}}</div>
                    </div>

                    <div class="live_robot_tips">
                        <p>{{msg.robot[0].brief}}</p>
                    </div>

                    <div class="live_robot_btn" @click.stop.prevent="openNative('robot_page', {
                        title: msg.robot[0].title,
                        o_kind: msg.robot[0].kind,
                        user_stock: msg.robot[0].user_stock
                    })">
                        <div>请输入股票名称或者代码</div>
                        <button>一键知涨跌</button>
                    </div>
                </div>
            </div>
        </template>

        <!-- other：非粉丝可见内容直接展示，粉丝可见内容需校验关注状态 -->
        <template v-else-if="((msg.kind === 'charge') || (msg.kind == 'vip') || (msg.kind === 'free') || (msg.kind === 'user_msg' && msg.content_type !== '0') ||  (msg.kind === 'user_msg' && msg.content_type === '0') ) && (msg.is_fans_show != '1' || (teacherInfo && teacherInfo.is_follow != 'no')) ">
            <div class="live_header" @click.stop.prevent="handleClickToLiveDetail">
                <div class="is_top_msg" v-if="msg.state2 === 'top'"></div>
                <dl class="user_detail" v-if="teacherInfo && teacherInfo.image">
                    <!-- 头像 -->
                    <dt @click.stop="handleClickToDetail('live_msg', teacherInfo)">
                        <img :src="teacherInfo.image" alt="用户头像" />
                    </dt>

                    <!-- 右侧 -->
                    <dd>
                        <h4>
                            <span @click.stop.prevent="handleClickToDetail('live_msg', teacherInfo)" class="user_name">{{ live.remark_name || live.title }}</span>
                            <template v-if="live && live.user_medals_tail && live.user_medals_tail.length > 0 && sourcePage != 'jf'">
                                <span
                                    class="user_symbol"
                                    v-for="(item, index) in live.user_medals_tail"
                                    :key="index"
                                    @click.stop="handleClickToDetail('live_msg', teacherInfo)"
                                >
                                    <img :src="item.image" alt="" />
                                </span>
                            </template>
                        </h4>
                        <p v-if="msg.rec_time_desc">{{ msg.rec_time_desc }}&nbsp;&nbsp;&nbsp;{{ sourcePage != 'jf' ? msg.view_num: '' }}</p>
                    </dd>
                </dl>

                <!-- 更多 - 三个点 -->
                <div
                    v-if="sourcePage != 'jf'"
                    class="user_operation"
                    @click.stop.prevent="handleClickShowMoreAction"
                >
                    <img :src="require('@/assets/images/icon-there-dot@2x.png')" />
                </div>
            </div>

            <div class="live_content_box">
                <div v-if="msg.kind === 'vip'">
                    <div v-if="msg.is_show === 'no' || !msg.content">
                        <div class="members_only">
                            <div
                                @click.stop.prevent="handleClickToLiveDetail"
                                :class="['members_only_free', apptextSize, 'bind_' + source]"
                                v-html="msg.brief"
                            >
                            </div>
                            <div class="members_only_box">
                                <div class="vip_nosee_company" @click.stop.prevent="handleClickToLiveDetail">
                                    <span></span>
                                    <div class="vip_company_info open_member">
                                        <b>会员专享信息，请开通VIP服务查看</b>
                                        <p v-if="msg.vip_group_info">[所属分组：{{ msg.vip_group_info }}]</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="msg.is_show === 'yes' && msg.content" @click.prevent="handleClickToLiveDetail">
                        <div class="member_brief" v-html="msg.brief"></div>
                        <div class="member_pad"></div>
                        <div class="member_news_box">
                            <div class="member_news">
                                <div class="member_news_header">
                                    <dl>
                                        <dt>
                                            <img alt :src="require('@/assets/images/icon-vip-yellow@2x.png')" />
                                        </dt>
                                        <dd>
                                            <h4>
                                                以下内容会员独享
                                                <span v-if="msg.vip_group_info">({{ msg.vip_group_info }})</span>
                                            </h4>
                                            <!-- <p>本收费产品由{{msg.company}}提供</p> -->
                                        </dd>
                                    </dl>
                                </div>

                                <div :class="['member_news_content', apptextSize, 'bind_' + source]" v-html="strParseFace(vip_content, msg.stock_info, msg.to_info)"></div>

                                <div
                                    v-if="(msg.img_hd && msg.img_hd.length > 0) || (msg.menus && msg.menus.length > 0)"
                                    @click.stop
                                >
                                    <image-viewpoint
                                        :msg="msg"
                                        bgColor="#fffbef"
                                    ></image-viewpoint>
                                </div>
                                <div class="member_content_pad"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 是否是高手免费消息 -->
                <div v-if="msg.kind === 'free' || (msg.kind === 'user_msg' && msg.content_type === '0')">
                    <div>
                        <!-- 文字部分 -->
                        <div :class="['live_content', apptextSize, 'bind_' + source]" v-if="msg.is_room_preview != '1'">
                            <div>
                                <div
                                    v-html="strParseFace(msg.content, msg.stock_info, msg.to_info)"
                                    @click="handleClickToLiveDetail"
                                ></div>
                            </div>
                        </div>

                        <!-- 直播预告 1||-->
                        <live-preview-card
                            v-if="msg.is_room_preview == '1'"
                            :info="msg"
                            :userInfo="live"
                            :applicationPage="applicationPage"
                            :pageName="pageName"
                        ></live-preview-card>

                        <!-- 音频消息 没了嗷 先注释了，以免报错 msg.audio && msg.audio !== '' -->

                        <!-- 图片部分有图片或者视屏则都显示缩略图 -->
                        <div v-if="msg.image && msg.image.length > 0 || (msg.menus && msg.menus.length > 0)">
                            <image-viewpoint :msg="msg"></image-viewpoint>
                        </div>

                        <!-- 股票 -->
                        <div v-if="msg.share_kind && msg.share_kind === 'stock' && msg.share_msg">
                            <!-- 股票组件 -->
                            <stock-card
                                :stockInfo="msg.share_msg"
                                :applicationPage="applicationPage"
                            ></stock-card>
                        </div>

                        <!-- 股票类型-板块 -->
                        <div v-if="msg.theme_info && Object.keys(msg.theme_info).length > 0 && msg.theme_info.id">
                            <!-- 股票组件 - 类型 -bk -->
                            <stock-card
                                type="theme"
                                :stockInfo="msg.theme_info"
                                :applicationPage="applicationPage"
                            ></stock-card>
                        </div>

                        <!-- 板块 theme类型的不清楚还有没有先留着 -->
                        <div v-if="msg.share_msg && msg.share_msg.length && msg.share_msg.share_msg_kind === 'theme'">
                            <!-- 股票组件 - 类型 -bk -->
                            <stock-card
                                type="theme"
                                :stockInfo="msg.share_msg"
                                :applicationPage="applicationPage"
                            ></stock-card>
                        </div>

                        <!-- 龙虎榜 -->
                        <div v-if="msg.share_kind && msg.share_kind == 'dragon_tiger_detail' && msg.share_msg">
                            <dragon-tiger-card
                                type="dragon_tiger_detail"
                                :msg="msg.share_msg"
                                :applicationPage="applicationPage"
                            ></dragon-tiger-card>
                        </div>

                        <!-- 竞猜todo -->
                        <div
                            v-if="msg.guess && msg.guess.id"
                            class="transpond_guess"
                        >
                           <guess-card
                                :guess="msg.guess"
                                :applicationPage="applicationPage"
                           ></guess-card>
                        </div>

                        <!-- 分享投票 -->
                        <div v-if="voteInfo && voteInfo.id">
                            <div class="transpond_vote_wrap">
                                <div class="transpond_vote_content">
                                    <div class="transpond_vote_title">{{ voteInfo.vote_title }}<span v-if="voteInfo.vote_type == '2'">(最多选{{voteInfo.max_select_num}}个)</span></div>
                                    <div class="transpond_vote_desc" v-if="voteInfo.vote_desc">
                                        {{ voteInfo.vote_desc }}
                                    </div>
                                    <div
                                        :class="['transpond_vote_items', {
                                            hasVoteSelect: hasVoteSelect
                                        }]"
                                    >
                                        <div
                                            v-for="(item, index) in voteInfo.option"
                                            :key="index"
                                            :class="[{
                                                bind_this: item.is_voted == 'yes'
                                            }]"
                                            @click.stop.prevent="setVoteSelectFn(item, index)"
                                        >
                                            <div class="transpond_vote_items_title">
                                                {{ item.option_title }}
                                            </div>
                                            <div v-if="hasVoteSelect">
                                                <span v-if="item.vote_number && item.vote_number != ''">{{ item.vote_number}}票</span>
                                                <span>{{item.proportion}}</span>
                                            </div>

                                            <div 
                                                :class="['transpond_vote_items_btn', {
                                                    bind_this: item.is_voted == 'yes'
                                                }]"
                                                :style="{
                                                    width: item.proportion
                                                }"
                                            >
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div class="transpond_vote_footer">
                                        <div class="close_time">{{ voteInfo.custom_ended_at }}</div>
                                        <div class="create_user">
                                            <span class="create_user_name">@{{ live.remark_name || live.title }}</span>&nbsp;创建
                                        </div>
                                    </div>
                                    <div class="transpond_vote_share_btn" v-if="hasVoteSelect">
                                        <button @click.stop.prevent="handleClickShareVotes" >分享我的投票和观点</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 分享期货 不到啊，我看这里注释了 msg.share_kind && !!~['futures'].indexOf(msg.share_kind) -->

                        <!-- 分享k线训练营-->
                        <div v-if="msg.share_kind && msg.share_kind == 'kline_game'">
                            <!-- TODO K -->
                            <k-line-card
                                :msg="msg"
                                :applicationPage="applicationPage"
                            ></k-line-card>
                        </div>

                        <!-- 模拟炒股大赛 -->
                        <div v-if="msg.share_kind && msg.share_kind == 'match_experience'">
                            <div class="transpond_quiz_box_wrap" @click.stop.prevent="handleClickMatchInfo(msg.share_msg, 'detail')">
                                <!-- TODO 模拟 -->
                                <div class="quiz_left">
                                    <div class="quiz_bg contest_bg_zh">
                                        <h1>{{ msg.share_msg.profit_rate }}%</h1>
                                        <h2>总收益</h2>
                                    </div>
                                    <div class="quiz_con">
                                        <h1>{{ msg.share_msg.group_name }}<i>炒股大赛</i></h1>
                                        <p>{{ msg.share_msg.max_stock_position_name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 模拟炒股大赛-首页  -->
                        <div v-if="msg.share_kind && msg.share_kind == 'replica_match_stock'">
                            <div class="transpond_quiz_box_wrap_bs"  @click.stop.prevent="handleClickMatchInfo(msg.share_msg, 'home')">
                                <!-- TODO 模拟 -->
                                <div class="transpond_title"></div>
                                <div class="transpond_detail">
                                    <div class="guess_list">
                                        <h5 class="guess_title">模拟炒股短线炒股大赛</h5>
                                        <p class="guess_info">{{ msg.share_msg.reward_tip }}</p>
                                    </div>
                                    <div class="guess_btns">
                                        <div class="guess_btn">查看比赛</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="msg.share_kind && msg.share_kind == 'stock_group'">
                            <!-- 转发组合todo -->
                            <div class="transpond_simulation_wrap_app">
                                <stock-group
                                    :msg="msg.share_msg"
                                    :applicationPage="applicationPage"
                                ></stock-group>
                            </div>
                        </div>

                        <!-- 分享语音直播间 -->
                        <div v-if="(msg.share_kind && !!~['share_audio_live'].indexOf(msg.share_kind))">
                            <audio-live-card
                                :info="msg.share_msg"
                                :userInfo="live"
                                :applicationPage="applicationPage"
                            ></audio-live-card>
                        </div>

                        <!-- 视频直播间 -->
                        <div v-if="(msg.share_kind && msg.share_kind == 'live_streaming')">
                            <div class="liveCardMain">
                                <p>@{{ msg.share_msg.user_name }} <span v-if="false">关注</span></p>
                                <live-card
                                    :info="msg.share_msg"
                                    :userInfo="live"
                                    :applicationPage="applicationPage"
                                ></live-card>
                            </div>
                        </div>

                        <!-- 属于转发的模块 -->
                        <div
                            class="forward24"
                            v-if="
                            msg.forward_info &&
                            msg.forward_info.length > 0 &&
                            msg.forward_info[0] &&
                            msg.share_kind !== 'live_streaming'
                        ">

                            <div v-if="msg.forward_info[0].forward_kind === 'stock_group'">
                                <!-- 转发组合todo -->
                                <div
                                    class="transpond_simulation_wrap_app"
                                    v-for="(item, index) in msg.forward_info"
                                    :key="'simulation' + index"
                                >
                                    <stock-group
                                        type="forward"
                                        :msg="item"
                                        :applicationPage="applicationPage"
                                    ></stock-group>
                                </div>
                            </div>

                            <div v-if="msg.forward_info[0].forward_kind === 'express'">
                                <!-- 转发资讯todo -->
                                <div
                                    class="transpond_important_news"
                                    v-for="(item, index) in msg.forward_info"
                                    :key="'express' + index"
                                >
                                    <div class="news_bg" @click.stop.prevent="handleClickNewsDetail('forward')">
                                        <p>
                                            <span class="important_news_mark">[资讯]&nbsp;</span>
                                            <span>{{ item.last_content }}</span>
                                            <span v-if="!slefNoHasImgVideo && item.menus.length" class="icon_video">
                                                <img :src="require('@/assets/images/icon_forward_video@2x.png')" alt />
                                            </span>
                                            <span v-else-if="!slefNoHasImgVideo && item.image.length" class="icon_img">
                                                <img :src="require('@/assets/images/icon_forward_img@2x.png')" alt />
                                            </span>
                                        </p>
                                    </div>
                                    <div
                                        class="transpond_ordinary_image"
                                        v-if="slefNoHasImgVideo && ((item.image && item.image.length) || (item.menus && item.menus.length))"
                                    >
                                        <image-viewpoint
                                            :msg="item"
                                            bgColor="#f5f6f7"
                                        ></image-viewpoint>
                                    </div>
                                </div>
                            </div>

                            <!-- 转发平台专栏 -->
                            <div v-if="msg.forward_info[0].forward_kind === 'news'">
                                <div
                                    class="transpond_special_column"
                                    v-for="(item, index) in msg.forward_info"
                                    :key="'news' + index"
                                    :class="{
                                        is_delete: item.is_delete == 'yes'|| item.fans_show_state == 'no'
                                    }"
                                >
                                    <template v-if="item.is_delete == 'yes' || item.fans_show_state == 'no'">
                                        <div class="transpond_special_column_delete">{{ item.last_content }}</div>
                                    </template>
                                    <template v-else>
                                        <div class="transpond_box">
                                            <div class="transpond_content" @click.stop.prevent="handleClickAGPNewsDetail('forward')">
                                                <h4 class="transpond_title">{{ item.title }}</h4>
                                                <p class="transpond_brief">
                                                    <span v-html="item.brief || item.last_content"></span>
                                                    <span v-if="!slefNoHasImgVideo && item.image" class="icon_img">
                                                        <img :src="require('@/assets/images/icon_forward_img@2x.png')" alt />
                                                    </span>
                                                </p>
                                            </div>
                                            <div class="transpond_ordinary_image" v-if="slefNoHasImgVideo && item.image">
                                                <image-viewpoint
                                                    :msg="{ image: [item.image], menus: [] }"
                                                ></image-viewpoint>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <!-- 转发专栏 -->
                            <div v-if="(
                                    (
                                        msg.forward_info[0].forward_kind === 'live_msg' ||
                                        msg.forward_info[0].forward_kind === 'user_msg'
                                    ) &&
                                    msg.forward_info[0] && msg.forward_info[0].kind === 'charge'
                                )"
                            >
                                <div class="transpond_special_column bind_share" v-for="(item, index) in msg.forward_info"
                                    :key="'column' + index">
                                    <div class="transpond_box">
                                        <div
                                            class="transpond_content"
                                            @click.stop.prevent="handleClickToTranspondLiveDetail('forward')"
                                        >
                                            <div class="user_msg">
                                                <span
                                                    class="user_name"
                                                    @click.stop.prevent="handleClickToDetail(item.forward_kind, item, 'forward')"
                                                >
                                                    {{ item.l_title }}
                                                </span>

                                                <span class="send_time">{{ item.rec_time_desc }}</span>
                                            </div>
                                            <h4 class="transpond_title">{{ item.title }}</h4>
                                            <p class="transpond_brief">
                                                <span v-html="item.brief || item.last_content"></span>

                                                <span
                                                    v-if="!slefNoHasImgVideo && item.menus && item.menus.length"
                                                    class="icon_video"
                                                >
                                                    <img :src="require('@/assets/images/icon_forward_video@2x.png')" alt />
                                                </span>
                                                <span
                                                    v-else-if="!slefNoHasImgVideo && item.image.length"
                                                    class="icon_img"
                                                >
                                                    <img :src="require('@/assets/images/icon_forward_img@2x.png')" alt />
                                                </span>
                                            </p>
                                        </div>
                                        <div
                                            class="transpond_ordinary_image"
                                            v-if="slefNoHasImgVideo && (item.image && item.image.length)"
                                        >
                                            <image-viewpoint
                                                :msg="item"
                                                bgColor='#f5f6f7'
                                            ></image-viewpoint>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 转发消息 -->
                            <div
                                class="transpond_vip_box"
                                v-if="!!~['live_msg', 'user_msg'].indexOf(msg.forward_info[0].forward_kind)"
                            >
                                <!-- 转发vip可见消息 -->
                                <div
                                    class="transpond_vip"
                                    v-if="~['vip'].indexOf(msg.forward_info[0].kind) && msg.forward_info[0].is_show === 'yes'"
                                >
                                    <div
                                        :class="['member_brief', 'transpond', apptextSize, 'bind_' + source]"
                                        @click.stop.prevent="handleClickToLiveDetail('forward')"
                                    >
                                        <span class="user_name" @click.stop.prevent="handleClickToDetail(msg.forward_info[0].forward_kind, msg.forward_info[0], 'forward')">{{ msg.forward_info[0].l_title || msg.forward_info[0].title }}:</span>
                                        {{ msg.forward_info[0].brief }}
                                    </div>
                                    <div class="member_pad"></div>
                                    <div class="member_news_box">
                                        <div
                                            class="member_news"
                                            @click.prevent="handleClickToLiveDetail('forward')"
                                        >
                                            <!-- TODO -->
                                            <div class="member_news_header">
                                                <dl>
                                                    <dt>
                                                        <img alt='' :src="require('@/assets/images/icon-vip-yellow@2x.png')" />
                                                    </dt>
                                                    <dd>
                                                        <h4>以下内容会员独享 {{ msg.forward_info[0].vip_group_info ? '(' + msg.forward_info[0].vip_group_info + ')' : null }}</h4>
                                                    </dd>
                                                </dl>
                                            </div>
                                            <div :class="['member_news_content', apptextSize, 'bind_' + source]">
                                                <span
                                                    v-html="strParseFace(forward_vip_content, msg.forward_info[0].stock_info, msg.forward_info[0].to_info)"
                                                ></span>
                                                <span
                                                    v-if="!slefNoHasImgVideo && msg.forward_info[0].menus.length"
                                                    class="icon_video"
                                                >
                                                    <img :src="require('@/assets/images/icon_forward_video@2x.png')" alt />
                                                </span>
                                                <span
                                                    v-else-if="!slefNoHasImgVideo && msg.forward_info[0].image.length"
                                                    class="icon_img"
                                                >
                                                    <img :src="require('@/assets/images/icon_forward_img@2x.png')" alt />
                                                </span>
                                            </div>
                                            <div
                                                class="transpond_ordinary_image"
                                                v-if="slefNoHasImgVideo && (msg.forward_info[0].image.length || msg.forward_info[0].menus.length)"
                                                @click.stop
                                            >
                                                <image-viewpoint
                                                    :msg="msg.forward_info[0]"
                                                    bgColor="#fffbef"
                                                ></image-viewpoint>
                                            </div>
                                            <div class="member_content_pad"></div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 转发vip不可见消息 -->
                                <div
                                    class="transpond_vip"
                                    v-if="~['vip'].indexOf(msg.forward_info[0].kind) && msg.forward_info[0].is_show === 'no'"
                                >
                                    <div class="members_only" v-for="(item, i) in msg.forward_info" :key="i">
                                        <div :class="['members_only_free', 'transpond', apptextSize, 'bind_' + source]"
                                            @click.stop.prevent="handleClickToLiveDetail('forward')">
                                            <span class="user_name">{{ item.title || item.l_title }}:</span>
                                            <span v-html="item.brief"></span>
                                        </div>
                                        <div class="members_only_box zf border-1px">
                                            <div class="vip_nosee_company" @click.stop.prevent="handleClickToLiveDetail('forward')">
                                                <span></span>
												<div class="vip_company_info open_member">
												    <b>会员专享信息，请开通VIP服务查看</b>
												    <p v-if="item.vip_group_info">[所属分组：{{ item.vip_group_info }}]</p>
												</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 转发普通消息 -->
                                <div v-if="!~['charge', 'vip'].indexOf(msg.forward_info[0].kind)">
                                    <div class="transpond_ordinary" v-for="(item, i) in msg.forward_info" :key="i">
                                        <div
                                            class="transpond_ordinary_content"
                                            v-if="item.forward_kind === 'live_msg' && item.is_room_preview != '1'"
                                        >
                                            <div
                                                @click.stop.prevent="handleClickToLiveDetail('forward')"
                                                class="transpond_ordinary_content_text"
                                            >
                                                <span
                                                    class="user_name"
                                                    @click.stop.prevent="handleClickToDetail(item.forward_kind, item, 'forward')"
                                                >{{ item.l_title || item.brief }}：</span>
												<template v-if="item.is_delete == 'yes' || item.fans_show_state == 'no'">
												    <span>{{ item.last_content }}</span>
												</template>
												<template v-else>
													<span v-html="strParseFace((item.content) || (item.last_content), item.stock_info, item.to_info)"></span>
												</template>
                                                <div v-if="item.vote_info && item.vote_info.length" class="icon_vote">
                                                    <span>【{{item.vote_info[0].vote_title}}】</span>
                                                    <span class="icon_vote_ico"><img :src="require('@/assets/images/icon_vote@2x.png')" alt />查看投票</span>
                                                </div>
                                                <span v-if="!slefNoHasImgVideo && item.menus && item.menus.length"
                                                    class="icon_video">
                                                    <img :src="require('@/assets/images/icon_forward_video@2x.png')" alt='' />
                                                </span>
                                                <span
                                                    v-else-if="!slefNoHasImgVideo && item.image.length"
                                                    class="icon_img"
                                                >
                                                    <img :src="require('@/assets/images/icon_forward_img@2x.png')" alt="" />
                                                </span>
                                            </div>
                                        </div>

                                        <div
                                            class="transpond_ordinary_content"
                                            v-else-if="item.forward_kind === 'user_msg' && item.is_room_preview != '1'"
                                        >
                                            <p
                                                class="transpond_ordinary_content_text_name"
                                                @click.stop.prevent="handleClickToDetail(item.forward_kind, item, 'forward')"
                                            >
                                                <span
                                                    class="user_name"
                                                >{{ item.l_title }}</span>
                                                <span class="send_time">{{ item.rec_time_desc }}</span>
                                            </p>
                                            <p
												class="transpond_ordinary_content_text_title" 
                                                @click.stop.prevent="handleClickToLiveDetail('forward')"
											>{{item.title}}</p>
                                            <div
                                                class="transpond_ordinary_content_text"
                                                @click.stop.prevent="handleClickToLiveDetail('forward')"
                                            >

                                                <span v-html="(item.content) || (item.last_content)"></span>
                                                <div v-if="item.vote_info && item.vote_info.length" class="icon_vote">
                                                    <span>【{{ item.vote_info[0].vote_title }}】</span>
                                                    <span class="icon_vote_ico"><img :src="require('@/assets/images/icon_vote@2x.png')" alt />查看投票</span>
                                                </div>

                                                <span
                                                    v-if="!slefNoHasImgVideo && item.menus && item.menus.length"
                                                    class="icon_video"
                                                >
                                                    <img :src="require('@/assets/images/icon_forward_video@2x.png')" alt />
                                                </span>
                                                <span
                                                    v-else-if="!slefNoHasImgVideo && item.image.length"
                                                    class="icon_img"
                                                >
                                                    <img :src="require('@/assets/images/icon_forward_img@2x.png')" alt />
                                                </span>
                                            </div>
                                        </div>

                                        <!-- 转发 - 直播预告 -->
                                        <div class="transpond_ordinary_live_card" v-if="item.is_room_preview == '1'">
                                            <p>
                                                <span
                                                    class="user_name"
                                                    @click.stop.prevent="handleClickToDetail(item.forward_kind, item, 'forward')"
                                                >{{ item.l_title || item.title }}</span>
                                                <span class="send_time">{{ item.rec_time_desc }}</span>
                                            </p>
                                            <template v-if="item.is_delete == 'yes' || item.fans_show_state == 'no'">
                                                <h1 class="transpond_ordinary_live_card_delete_title">{{ item.content }}</h1>
                                                <p class="transpond_ordinary_live_card_delete_p">{{ item.last_content }}</p>
                                            </template>
                                            <live-preview-card
                                                v-else
                                                :info="item"
                                                :userInfo="live"
                                                :applicationPage="applicationPage"
                                            ></live-preview-card>
                                        </div>

                                        <!-- 满足消息本身没有图片并且转发的消息有图片时显示转发的图片-->
                                        <div
                                            class="transpond_ordinary_image"
                                            v-if="slefNoHasImgVideo && (item.image && item.image.length || item.menus && item.menus.length)"
                                        >
                                            <image-viewpoint :msg="item" bgColor="#f5f6f7"></image-viewpoint>
                                        </div>

                                        <div class="forward-main">
                                            <!-- 转发消息中的板块 -->
                                            <div
                                                v-if="item.share_msg && item.share_msg.length && item.share_msg[0].share_msg_kind === 'theme'"
                                            >
                                                <!-- 股票组件 - 类型 -bk -->
                                                <stock-card
                                                    type="theme"
                                                    :stockInfo="item.share_msg"
                                                    :applicationPage="applicationPage"
                                                ></stock-card>
                                            </div>

                                            <!-- 转发消息中的分享竞猜 -->
                                            <div
                                                v-if="item.guess && item.guess.length"
                                                class="transpond_guess"
                                            >
                                                <guess-card
                                                    :guess="item.guess"
                                                    :applicationPage="applicationPage"
                                                ></guess-card>
                                            </div>

                                            <!-- 转发消息中的股票 -->
                                            <div v-if="item.share_msg && item.share_kind && item.share_kind === 'stock'">
                                                <stock-card
                                                    :stockInfo="item.share_msg"
                                                    :applicationPage="applicationPage"
                                                ></stock-card>
                                            </div>

                                            <!-- 股票类型-板块 -->
                                            <div v-if="item.theme_info && Object.keys(item.theme_info).length > 0 && item.theme_info.id">
                                                <!-- 股票组件 - 类型 -bk -->
                                                <stock-card
                                                    type="theme"
                                                    :stockInfo="item.theme_info"
                                                    :applicationPage="applicationPage"
                                                ></stock-card>
                                            </div>

                                            <!-- 转发 - 龙虎榜 -->
                                            <div v-if="item.share_msg && item.share_kind && item.share_kind === 'dragon_tiger_detail'">
                                                <dragon-tiger-card
                                                    type="dragon_tiger_detail"
                                                    :msg="item.share_msg"
                                                    :applicationPage="applicationPage"
                                                ></dragon-tiger-card>
                                            </div>

                                            <!-- 转发消息中k线训练营-->
                                            <div
                                                v-if="item.share_msg && item.share_kind && item.share_kind === 'kline_game'"
                                            >
                                                <!-- TODO K -->
                                                <k-line-card
                                                    :msg="item"
                                                    :applicationPage="applicationPage"
                                                ></k-line-card>
                                            </div>

                                            <!-- 转发 - 模拟炒股 -->
                                            <div
                                                class="transpond_quiz_box_wrap_main"
                                                v-if="item.share_msg && item.share_kind && item.share_kind == 'match_experience'"
                                            >
                                                <div class="transpond_quiz_box_wrap" @click.stop.prevent="handleClickMatchInfo(item.share_msg, 'detail')">
                                                    <!-- TODO 模拟 -->
                                                    <div class="quiz_left">
                                                        <div class="quiz_bg contest_bg_zh">
                                                            <h1>{{ item.share_msg.profit_rate }}%</h1>
                                                            <h2>总收益</h2>
                                                        </div>
                                                        <div class="quiz_con">
                                                            <h1>{{ item.share_msg.group_name }}<i>炒股大赛</i></h1>
                                                            <p>{{ item.share_msg.max_stock_position_name }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 转发 - 模拟炒股大赛首页 -->
                                            <div v-if="item.share_kind && item.share_kind == 'replica_match_stock'">
                                                <div class="transpond_quiz_box_wrap_bs" @click.stop.prevent="handleClickMatchInfo(item.share_msg, 'home')">
                                                    <!-- TODO 模拟 -->
                                                    <div class="transpond_title"></div>
                                                    <div class="transpond_detail">
                                                        <div class="guess_list">
                                                            <h5 class="guess_title">模拟炒股短线炒股大赛</h5>
                                                            <p class="guess_info">{{ item.share_msg.reward_tip }}</p>
                                                        </div>
                                                        <div class="guess_btns">
                                                            <div class="guess_btn">查看比赛</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="item.share_kind && item.share_kind == 'stock_group'">
                                                <!-- 转发组合todo -->
                                                <div class="transpond_simulation_wrap_app" >
                                                    <stock-group
                                                        type="forwardShare"
                                                        :msg="item.share_msg"
                                                        :applicationPage="applicationPage"
                                                    ></stock-group>
                                                </div>
                                                
                                            </div>

                                            <!-- 分享语音直播间 -->
                                            <div
                                                v-if="item.share_msg && item.share_kind && item.share_kind === 'share_audio_live'"
                                            >
                                                <audio-live-card
                                                    :info="item.share_msg"
                                                    :userInfo="live"
                                                    :applicationPage="applicationPage"
                                                ></audio-live-card>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p
                                v-if="
									msg.forward_info[0].comment_num &&
									msg.forward_info[0].comment_num > 0 &&
									msg.forward_info[0].kind != 'vip' &&
									( 
										msg.forward_info[0].is_delete != 'yes' &&
										msg.forward_info[0].fans_show_state != 'no'
									)
								"
                                class="transpond_quiz_box_wrap_bs_p"
                            >相关讨论({{ msg.forward_info[0].comment_num }})</p>
                        </div>
                    </div>
                </div>

                <!-- 是否是高手专栏 -->
                <div v-if="msg.kind === 'charge'">
                    <div class="special_column">
                        <h4 :class="['special_column_title','special_column_title2', apptextSize, 'bind_' + source]" @click.stop.prevent="handleClickToLiveDetail">{{ msg.title}}</h4>
                        <p
                            :class="['special_column_content', apptextSize, 'bind_' + source]"
                            v-html="strParseFace(kindChargeAddSpan, msg.stock_info, msg.to_info)"
                            @click="handleClickToLiveDetail"
                        ></p>
                    </div>
                    <div v-if="msg.image && msg.image.length > 0 && parseInt(msg.price) === 0">
                        <image-viewpoint :msg="msg"></image-viewpoint>
                    </div>
                    <div
                        v-if="parseInt(msg.price) > 0"
                        class="charge_kaitong_box"
                        @click.stop.prevent="handleClickToLiveDetail"
                    >
                        <div class="charge_kaitong">
                            <span v-if="is_vip === 'no'">
                                本篇为付费专栏文章
                                <i class="price_text">￥{{ parseInt(msg.price) }}.00</i>
                            </span>
                            <span v-else-if="msg.vip_price === '0'">付费专栏文章会员免费</span>
                            <span v-else>
                                付费专栏文章会员专享
                                <i class="price_text">￥{{ msg.vip_price }}.00</i>
                            </span>
                        </div>
                    </div>
                </div>
                
                <div v-if="msg.kind === 'user_msg' && msg.content_type !== '0'">
                    <div class="special_column" >
                        <h4 :class="['special_column_title', apptextSize, 'bind_' + source]" @click.stop.prevent="handleClickToLiveDetail">{{ msg.title}}</h4>
                        <p
                            :class="['special_column_content', apptextSize, 'bind_' + source]"
                            v-html="strParseFace(msg.content, msg.stock_info, msg.to_info)"
                            @click="handleClickToLiveDetail"
                        ></p>
                    </div>
                    <div v-if="msg.img_hd && msg.img_hd.length > 0">
                        <image-viewpoint :msg="msg"></image-viewpoint>
                    </div>
                </div>

                <!-- 附件 -->
                <div v-if="msg.file && msg.file.length > 0">
                    <div class="file_wrap24_wrap">
                        <div
                            class="file_wrap24"
                            v-for="(item, index) in msg.file"
                            :key="index"
                            @click.stop.prevent="handleClickFileDetail(item, index)"
                        >
                            <div class="file_wrap">
                                <div class="file_box">
                                    <div :class="['file_box_img', item.file_type + '_img']"></div>
                                    <div
                                        class="file_box_view_rf"
                                        :data-type="item.file_type"
                                        :data-name="item.file_name"
                                        :data-link="fileLinkFn(item)"
                                    ><p>{{ item.file_name }}</p><span>({{item.file_size}})</span></div>
                                    <button
                                        class="file_box_download"
                                        :data-name="item.file_name"
                                        :data-link="item.file_link"
                                    ></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 标签 -->
                <div v-if="msg.kind == 'charge' && (msg.article_category_name && msg.article_category_name != '' || topicInfo)"> <!--  || data.content_type == 1 -->
                    <div class="article_kind_box">
                        <!-- article_category_id -->
                        <button
                            class="article_kind" 
                            v-if="msg.article_category_name && msg.article_category_name != ''"
                            :style="{
                                'background-image': 'url(' + msg.article_category_icon + ')'
                            }"
                            @click.stop.prevent="handleClickArticleKindDetail(msg)"
                        >
                            {{msg.article_category_name}}
                        </button>
                        <button
                            class="article_topic_card"
                            v-if="topicInfo"
                            @click.stop.prevent="handleClickTopicDetail"
                        >
                            {{topicInfo.title}}
                        </button>
                    </div>
                </div>
            </div>

            <div :class="['live_footer', {
                 hasBtm: sourcePage == 'jf'
            }]">
                <div class="footer_top_border"  v-if="sourcePage != 'jf'">
                    <!-- 点赞 -->
                    <div class="give_like">
                        <span class="ub align-items justify-content" @click.stop.prevent="handleClickToLike">
                            <img 
                                v-if="isSupport === 'yes'"
                                class="isOccurLike"
                                :src="require('@/assets/images/icon_like_new_red@2x.png')"
                            />
                            <img v-if="isSupport !== 'yes'" :src="require('@/assets/images/icon_like_new.png')" alt />
                            <span :class="['support_num', isSupport === 'yes' ? 'to_red' : '']">{{supportNum > 0? supportNum: '点赞'}}</span>
                        </span>
                    </div>

                    <!-- 分享 -->
                    <div
                        class="give_comment"
                        v-if="msg.only_self_show == 'no' && (msg.is_shareto_outside == '1' && msg.shareable == '1')"
                    >
                        <span class="ub align-items justify-content" @click.stop.prevent="handleClickShareCard">
                            <img :src="require('@/assets/images/icon_msg_share.png')" alt />
                            <span>{{msg.share_num > 0? msg.share_num: '分享'}}</span>
                        </span>
                    </div>

                    <!-- 评论 -->
                    <div class="give_comment" @click.stop.prevent="handleClickToComment">
                        <span class="ub align-items justify-content">
                            <img 
                                v-if="+msg.comment_num > 0"
                                :src="require('@/assets/images/icon_comment_new_red@2x.png')"
                                alt=""
                            />
                            <img
                                v-if="+msg.comment_num <= 0"
                                :src="require('@/assets/images/icon_comment_new.png')"
                                alt=""
                            />
                            <span
                                :class="+msg.comment_num > 0 ?'to_red': ''"
                            >{{ msg.comment_num == 0
                                ?'评论':msg.comment_num
                            }}</span>
                        </span>
                    </div>
                </div>
            </div>

            <!-- 
                [评论区]

                展示规则
                - 列表存在 并且 列表数据大于0 并且 等于 3(等于3这个先去掉 指定这个规则也去掉)
                - 不是置顶
				
				&& msg.part_comment.length == 3 
				&& msg.state2 !== 'top'
            -->
            <div class="liver_comment_wrap" v-if="msg.part_comment && msg.part_comment.length > 0 && sourcePage != 'jf'">
                <div>
                    <div class="liver_comment_list">
                        <div
                            v-for="(item, index) in msg.part_comment"
                            :key="index"
                            :class="['liver_comment_li']"
                        >
                            
                            <p>
                                <span class="liver_comment_li_name" @click.stop.prevent="handleClickCommentUser(item.role_1, item.liver_id_1)">{{item.nickname_1}}<i :class="[{is_liver: item.role_1 == 'liver' || item.role_1 == 'liver_official', is_talent: item.role_1 == 'is_talent'}]"></i>{{ item.nickname_2? '': '：' }}</span>
                                {{ item.nickname_2?'回复': '' }}
                                <span v-if="item.nickname_2" class="liver_comment_li_name" @click.stop.prevent="handleClickCommentUser(item.role_2, item.liver_id_2)">{{item.nickname_2}}<i :class="[{is_liver: item.role_2 == 'liver' || item.role_2 == 'r_liver_official' || item.role_2 == 'r_liver' || item.role_2 == 'liver_official', is_talent: item.role_2 == 'is_talent' || item.role_2 == 'r_is_talent'}]"></i>：</span>
                                <span v-html="strParseFace(item.content)" @click.stop.prevent="handleClickToComment"></span>
                            </p>
                        </div>
                    </div>
                    <div class="liver_comment_btn"><button @click.stop.prevent="handleClickToComment">查看所有评论</button></div>
                </div>
            </div>
        </template>

        <!-- 仅粉丝可见且未关注：展示关注引导 -->
        <template v-else-if="msg.is_fans_show == '1' && (!teacherInfo || teacherInfo.is_follow == 'no')">
            <div class="nofans js-nofans" @click.stop.prevent="showFollow">此内容仅粉丝可见，关注作者后即可查看</div>
        </template>

        <!-- 
            [可见范围展示]

            展示规则
            -   必须为主页 listname == homepage

            -   如果是老师自己查看 isSelf == true
             ·  比对时间戳，在最后面的第一个展示
             ·  不能为置顶

            -   如果是普通用户 isSelf == false
             ·  在列表的最后一个出现
        -->
        <!-- 老师版本 -->
        <template v-if="
            listname == 'homepage' &&
            msg.state2 != 'top' &&
            isSelf &&
            view_range_show &&
            view_range_show.saveId &&
            view_range_show.saveId == msg.id
        ">
            <div class="view_range_show">
                <p>以下内容未对他人公开</p>
                <button>前往设置</button>
            </div>
        </template>


    </div>
</template>
<script>
import { isGoUp, highLight, highLightAtUser, parseUrlLink } from "@/utils/index";
import { FollowFansDialog } from "@/utils/followFansDialog";
import { u_id, source, appversion } from "@/utils/urlQuery";
import userHomeApi from "@/api/user_home/index.js";
import { Toast, Dialog } from 'vant';
export default {
    name: "appLiveListPub",
    props: {
        item: Object,
        live: Object,
        msg: Object,
        is_vip: String,
        indexItem: Number,
        teacherInfo: Object, // 老师信息
        applicationPage: { // 应用页面 封装成组件【list, detail】列表 - 详情页
            type: String,
            default: "list"
        },
        view_range_show: {  // 判断底部是否显示可见信息
            type: Object,
            default: () => {
                return {};
            }
        },
        isSelf: {   // 是否是老师本人
            type: Boolean,
            default: false
        },
        listname: { // 列表名字
            type: String,
            default: ""
        },
        pageName: {
            type: String,
            default: "teacher"
        },
        vip_content: {
            type: String,
            default: ""
        },
        forward_vip_content: {
            type: String,
            default: ""
        },
        apptextSize: {
            type: String,
            default: "normal"
        },
        sourcePage: {
            type: String,
            default: ""
        }
    },
    components: {
        imageViewpoint: () => import("@/components/userHome/imageViewpoint.vue"),
        livePreviewCard: () => import("@/components/userHome/livePreviewCard"), // 直播预告
        liveCard: () => import("@/components/userHome/liveCard"), // 直播
        stockCard: () => import("@/components/userHome/components/stockCard"), // 股票 - 板块
        stockGroup: () => import("@/components/userHome/components/stockGroup"), // 模拟组合
        guessCard: () => import("@/components/userHome/components/guessCard"), // 竞猜
        audioLiveCard: () => import("@/components/userHome/components/audioLiveCard"), // 语音直播间
        kLineCard: () => import("@/components/userHome/components/kLineCard"), // K线训练营
        dragonTigerCard: () => import("@/components/userHome/components/dragonTigerList.vue"), // 龙虎榜
    },
    data() {
        return {
            u_id,
            voteInfo: null,
            topicInfo: null,
            hasVoteSelect: false,
            randomStr: Math.random().toString(36).slice(-4),
            user_id: parseInt(this.$route.params.user_id),
            faceList: { "\u5fae\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_weixiao@3x.png", "\u9707\u60ca": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhenjing@3x.png", "\u6487\u5634": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_piezui@3x.png", "\u8272": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_se@3x.png", "\u5927\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_daku@3x.png", "\u9177": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ku@3x.png", "\u594b\u6597": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_fendou@3x.png", "\u7591\u95ee": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_yiwen@3x.png", "\u574f\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_huaixiao@3x.png", "\u9634\u9669": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_yinxian@3x.png", "\u4eb2\u4eb2": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qinqin@3x.png", "\u53ef\u601c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kelian@3x.png", "OK": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_OK@3x.png", "\u98de\u543b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_feiwen@3x.png", "\u60b2\u4f24": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_beishang@3x.png", "\u6c57": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_han@3x.png", "\u6342\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wulian@3x.png", "\u5927\u6012": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_danu@3x.png", "\u6012\u706b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_nuhuo@3x.png", "\u5455": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ou@3x.png", "dog": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_dog@3x.png", "\u94b1": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qian@3x.png", "\u5410\u8840": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_tuxue@3x.png", "\u6342\u5634\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wuzuixiao@3x.png", "\u61f5": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_meng@3x.png", "\u53cb\u5584": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_youshan@3x.png", "\u60e8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_can@3x.png", "\u4e27": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_sang@3x.png", "\u6311\u7709": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_tiaomei@3x.png", "\u7b11\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_xiaoku@3x.png", "\u7761\u89c9": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_shuijiao@3x.png", "\u53ef\u7231": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_keai@3x.png", "\u5657": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_pu@3x.png", "\u6c14\u6124": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qifen@3x.png", "\u5927\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_daxiao@3x.png", "\u611f\u5192\u4e86": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kouzhao@3x.png", "\u5201\u96be": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_diaonan@3x.png", "\u67e0\u6aac": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ningmeng@3x.png", "\u771f\u725b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhenniu@3x.png", "\u65e9\u5b89": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zaoan@3x.png", "\u665a\u5b89": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wanan@3x.png", "\u7a7a\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kongcang@3x.png", "\u6ee1\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_mancang@3x.png", "\u51cf\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jiancang@3x.png", "\u52a0\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jiacang@3x.png", "\u6da8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhang@3x.png", "\u8dcc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_die@3x.png", "\u8e29": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_cai@3x.png", "\u9876": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ding@3x.png", "\u80dc\u5229": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_shengli@3x.png", "\u91d1\u5e01": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jinbi@3x.png", "dog\u6342\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dog_wulian2021-08-23@3x.png", "dog\u7b11\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dog_xiaoku2021-08-23@3x.png", "\u7231\u5fc3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/aixin2021-08-23@3x.png", "\u5315\u9996": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/bishou2021-08-23@3x.png", "\u6284\u5e95": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chaodi2021-08-23@3x.png", "\u5403\u74dc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chigua2021-08-23@3x.png", "\u5403\u8089": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chirou2021-08-23@3x.png", "\u6253call": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dacall2021-08-23l@3x.png", "\u4e8c\u54c8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/erha2021-08-23@3x.png", "\u7ea2\u5305": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/hongbao2021-08-23@3x.png", "\u97ed\u83dc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/jiucai2021-08-23@3x.png", "\u9152": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/jiu2021-08-23@3x.png", "\u88c2\u5f00": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/liekai2021-08-23@3x.png", "\u5e72\u676f": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/pijiu2021-08-23@3x.png", "\u5e86\u795d": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/qingzhu2021-08-23@3x.png", "\u5fc3\u788e": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/xinsui2021-08-23@3x.png", "\u836f": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/yao2021-08-23@3x.png", "666": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/666_v3.png", "\u767d\u773c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/baiyan_v3.png", "\u6253\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dalian_v3.png", "\u9f13\u638c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/guzhang_v3.png", "\u62a0\u9f3b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/koubi_v3.png", "\u96be\u8fc7": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/nanguo_v3.png", "\u53f9\u6c14": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/tanqi_v3.png", "\u6293\u72c2": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/zhuakuang_v3.png", "\u9f87\u7259": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/ziya_v3.png", "\u4e70": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/0e2f6f9ac9666b0cbf46bbf18fb15528=200X200.png", "\u8df3\u6c34": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/d938c427247c2c9dfc0c0ff3edee75ed=200X200.png", "\u7a7a": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/7b5cc2714dc25772900d3c8924237b22=200X200.png", "\u591a": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/4fe79dc6598e28957f02439e81eb7a68=200X200.png", "\u5403\u9762": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/140199629c06eca7f7f4c63cec870bd0=200X200.png", "\u68ad\u54c8": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/90cb956f181acaf875b1c7a857937112=200X200.png", "\u5356": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/2263373d61c164c7ecd0d2551dc82323=200X200.png", "\u62b1\u62f3": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/f838a3021272c8fdfc580ad8992be7a7=100X100.png", "\u7948\u7977": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/cf0006b5b512a9e8d3946b19166d28c2=100X100.png", "\u63e1\u624b": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/e2d6ab55fc734846651fddf0fb363a06=100X100.png" },
            isSupport: "no", // 点赞状态
            supportNum: 0, // 点赞数
            supportStr: "", // 点赞存储的字符
            reqLoading: false, // 接口请求状态
            source,
        };
    },
    computed: {
        hasGetInfo() {
            return this.$store.state.user.hasGetInfo;
        },
        slefNoHasImgVideo() {
            return this.msg.image.length === 0 && this.msg.menus.length === 0;
        },
        kindChargeAddSpan() { // 类型为charge的文章，增加“全文”标签
            let msg = this.msg;
            let content = msg.brief || msg.content;

            return content+='<span class="allBtn">...全文</span>'
        }
    },
    created() {
        let msg = this.msg;
        // 投票 - start
        if(msg.vote_info && msg.vote_info.length > 0) {
            let voteInfo = msg.vote_info[0], hasVoteSelect = false;
            let options = voteInfo.option;
            for(let i=0,ilen=options.length;i<ilen;i++) {
                if(options[i].is_voted == 'yes') {
                    hasVoteSelect = true;
                    break;
                }
            }
            this.voteInfo = voteInfo;
            this.hasVoteSelect = hasVoteSelect;
        }
        // 投票 - end

        // 话题 - start
        if(msg.topic && msg.topic.length > 0) {
            let topicList = msg.topic, topicInfo = null;
            console.info(topicList,'TOPICLIST')
            for(let i=0,ilen=topicList.length;i<ilen;i++) {
                if(topicList[i].is_hot == '1' && topicList[i].is_delete == '0' && topicList[i].title) {
                    let reg = new RegExp('#','g');
                    topicList[i].title = topicList[i].title.replace(reg,'');
                    topicInfo = topicList[i];
                    break;
                }
            }

            if(topicInfo) {
                this.topicInfo = topicInfo;
            }
        }
        // 话题 - end

        // 点赞状态 -start
        let supportStr = 'live_msg_' + msg.id;
        // isSupport
        if(localStorage && localStorage[supportStr]) {
            let value = localStorage[supportStr] || 'no';
            this.isSupport = value;
        }
        this.supportStr = supportStr;
        this.supportNum = msg.support_num;
        // 点赞状态 - end

        // 加密内容
        if(msg.kind == 'vip' && msg.is_show === 'yes') {
            this.$srH5CallNativeMethodApp('call_rsa_content', {
                [msg.id]: msg.content
            })
        }

        if(msg && msg.forward_info && msg.forward_info.length > 0 && msg.forward_info[0].kind && msg.forward_info[0].kind == 'vip' && msg.forward_info[0].is_show === 'yes') {
            this.$srH5CallNativeMethodApp('call_rsa_content', {
                [msg.id + '_' + msg.forward_info[0].id]: msg.forward_info[0].content || msg.forward_info[0].last_content || msg.forward_info[0].brief
            })
        }
        // 加密内容

        // 匹配超链 一个链接帖子，换成短链接https://mobilebeta.aigupiao.com/lives/detail/id/4057323/share_id/ZDJsL3dubUEwMTIzRW0yYVdB噜噜噜噜噜
        
    },
    methods: {
        // 打开粉丝可见关注弹窗（通过公共弹窗控制器跨页面调用）
        showFollow() {
            if (!this.teacherInfo) return;
            FollowFansDialog.show({
                avatar: this.teacherInfo.image,
                nickname: this.teacherInfo.remark_name || this.teacherInfo.title,
                l_id: this.teacherInfo.l_id,
                onSuccess: (data) => {
                    // 关注成功后，更新本地 teacherInfo 关注状态
                    // teacherInfo 与 user_home 页的 userInfo 为同一引用，同步刷新
                    this.$set(this.teacherInfo, 'is_follow', 'yes');
                    this.$emit('follow-success', data);
                }
            });
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let msg = this.msg;
            console.info(msg,'当前用户的信息')
            let params = {
                kind: type, // 类型
            };

            // 同步传参
            params = {
                ...params,
                ...query
            }

            let APVERSION = appversion || "1160";
            if(APVERSION) {
                if(APVERSION.indexOf(".")>-1) {
                    APVERSION = APVERSION.split(".").join('')
                }
            }

            switch(type) {
                case "vip_product": // 会员产品页面
                    if(APVERSION >= 1292 && live && live.wx_jump_url) {
                        location.href = live.wx_jump_url;
                        return
                    } else {
                        params.url = `/up/app/vip_product/wap/?l_id=${this.l_id}`;
                    }
                    break;
                case "match_page": // 模拟炒股大赛 主页
                    break;
                case "match_detail_page": // 模拟炒股大赛-详情页 - 可能需要ID
                    break;
                case "group_detail_page": // 查看某人的模拟组合页面
                    break;
                case "detail_page": // 内容详情页
                    params.type = this.pageName;
                    if(params.forward) {
                        if(msg.forward_info && msg.forward_info.length > 0) {
                            params.o_kind = msg.forward_info[0].kind;
                            params.id = msg.forward_info[0].id;
                        }
                    } else {
                        params.o_kind = msg.kind;
                        params.id = msg.id;
                    }

                    if(source == "android") {
                        params.fromHome = "yes"
                    }
                    // params.url = "";// 详情页地址
                    break;
                case "news_page": // 资讯详情页
                    break;
                case "robot_page": // 机器人诊股页面
                    break;
                case "share_card": // 分享
                    break;
                case "file_page": // 附件
                    break;
                case "column_page": // 专栏文章 - 类型
                    break;
                case "share_vote_info": // 转发投票信息 【分享我的投票和观点】
                    break;
                case "topic_page": // 话题详情页
                    break;
                case "adv_live_msg": // VIP消息页面
                    break;
				case "person_page": // 用户详情页
					break;
            }

            // if(this.sourcePage == 'jf' && (type == 'detail_page' || params.o_kind == 'vip' && source != 'android')) {
            //     this.openNative('adv_live_msg', {
            //         url: `/up/app/advJFLiveMsg?id=${params.id}&scroll_btm=${params.fixedComment||'no'}`,
            //         id: params.id,
            //         fixedComment: params.fixedComment || 'no',
            //     });
            //     return
            // }

            
            if(params.o_kind == 'vip' && this.sourcePage == 'jf') {
                location.href = "https://agree.haoguvip.com?igpFunToAppJump_kind=buy_liver_vip_jf&jump_id=" + this.live.l_id
                return
            }


            if(params.o_kind == 'vip' && source != 'android') {
                if(msg.no_vip_can_to_detail != ''){
                    const message = `<div class="vip_group_wrap_center">${msg.no_vip_can_to_detail}</div>`
                    Dialog.alert({
                        title: '提示',
                        message,
                        className: 'custom-dialog',
                    }).then(() => {
                        // on close
                    });
                    return false;
                }
                let url = `/up/app/advLiveMsg?id=${params.id}&scroll_btm=${params.fixedComment||'no'}`;
                this.openNative('adv_live_msg', {
                    url: url,
                    id: params.id,
                    fixedComment: params.fixedComment || 'no',
                    fromHome: "yes"
                });
                return
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },
        fileLinkFn(file_single) {
            let href_link = file_single.file_link, mc_base = "https://view.officeapps.live.com/op/view.aspx?src=";
            let newUrl = `https://view.xdocin.com/view?src=`;

            if(href_link.indexOf("img1-cdn-picsh.stock-ring.com/download/") > -1) {
                href_link =  `${newUrl}${encodeURIComponent(href_link)}`;
            } else {
                if(file_single.file_type !== 'pdf') {
                    href_link = (mc_base + file_single.file_link)
                }
                if(file_single.file_type === 'txt') {
                    href_link = file_single.file_link;
                }
            }
            return file_single;
        },
        // 点赞
        async handleClickToLike() {
            if(this.reqLoading) {
                return
            }
            this.reqLoading = true;
            //点赞功能
            let {id} = this.msg;
            let is_support = this.isSupport, support_num = this.supportNum;
            let type = 'support'
            if (is_support != "yes") {
                // 点赞
                is_support = "yes"
                support_num = parseInt(support_num) + 1;

                this.$srH5CallNativeMethodApp('support_style',{})
            } else {
                // 取消点赞
                is_support = 'no';
                type = 'cancel_support';
                if(support_num - 1 <= 0) {

                } else {
                    support_num = parseInt(support_num) - 1;
                }
            }

            
            this.isSupport = is_support;
            this.supportNum = support_num;

            let res = await userHomeApi.setAttitude({
                act: "publish",
                kind: "live_msg",
                type,
                id
            })

            if(res.rslt == 'succ') {
                localStorage[this.supportStr] = is_support;
            }
            this.reqLoading = false;
        },
        // 直播详情
        handleClickToLiveDetail(forward = '') {
            if(!$(event.target).hasClass('p-a-link') && !$(event.target).hasClass('p-url-link')) {
                this.openNative('detail_page', {
                    forward: forward == 'forward'? forward: '',
                    query: this.msg,
                });
            }
        },
        // 资讯跳转详情
        handleClickNewsDetail(forward = "") {
            if(!$(event.target).hasClass('p-a-link') && !$(event.target).hasClass('p-url-link')) {
                this.openNative('detail_page', {
                    forward: forward == 'forward'? forward: '',
                    query: this.msg,
                });
            }
        },
        // 平台专栏跳转详情
        handleClickAGPNewsDetail(forward = '') {
            if(!$(event.target).hasClass('p-a-link') && !$(event.target).hasClass('p-url-link')) {
                this.openNative('detail_page', {
                    forward: forward == 'forward'? forward: '',
                    query: this.msg,
                });
            }
        },
        // 点击转发的主体跳转直播详情页面
        handleClickToTranspondLiveDetail(forward = '') {
            if(!$(event.target).hasClass('p-a-link') && !$(event.target).hasClass('p-url-link')) {
                this.openNative('detail_page', {
                    forward: forward == 'forward'? forward: '',
                    query: this.msg,
                });
            }
        },
        //点击评论跳转至直播详情页
        handleClickToComment() {
            this.openNative('detail_page', {
                forward: "",
                fixedComment: "yes",
                query: this.msg,
            });
        },
        // 点击附件跳转
        handleClickFileDetail(item, index) {
            this.openNative("file_page", {
                name: item.file_name,
                fileName: item.file_name,
                fileSize: item.file_size,
                fileType: item.file_type,
                fileLink: item.file_link
            });
        },
        // 题材行业 个股研究 复盘实业
        handleClickArticleKindDetail(msg) {
            this.openNative("column_page", {
                id: msg.article_category_id
            });
        },
        // 话题
        handleClickTopicDetail() {
            this.openNative("topic_page", {
                id: this.topicInfo.id
            })
        },
        // 貌似是用户详情
        handleClickToDetail(kind, info, forward) {
			let id = info.l_id;
			if(forward == 'forward') {
				id = info.l_id;
			}
            //如果已经在个人主页则不再做跳转
            if (this.l_id === parseInt(id)) {
                return null;
            }
			this.openNative('person_page', {
				o_kind: kind, // 用户身份（投顾老师、普通用户
				id
			});
            console.info(kind,id,'跳转用户主页 -> handleClickToDetail')
        },
		handleClickCommentUser(role, id) {
			let kind = ""
			if(role == 'liver') {
				kind = 'live_msg';
			} else if(role == 'user') {
				kind = 'user_msg';
			}
			if(!kind) return
			this.openNative('person_page', {
				o_kind: kind, // 用户身份（投顾老师、普通用户
				id
			});
		},
        // 点击更多按钮
        handleClickShowMoreAction() {
            this.$srH5CallNativeMethodApp('show_more_action', {
                index: this.indexItem,
                type: this.pageName,
                query: this.msg
            })
        },
        handleClickShareCard() {
            this.$srH5CallNativeMethodApp('share_card', {
                index: this.indexItem,
                query: this.msg
            })
        },
        // 跳转模拟炒股大赛详情页
        handleClickMatchInfo(info, type) {
            if(type == 'home') {
                this.openNative("match_page")
            } else {
                this.openNative("match_detail_page", {
                    id: info.match_id || 1
                })
            }
        },
        // 点击分享投票信息
        handleClickShareVotes() {
            this.$srH5CallNativeMethodApp('share_vote_info', {
                index: this.indexItem,
                query: this.msg
            })
        },
        // 字符串替换
        strParseFace(_str, stock_info = [], to_info = []) {
            // 解析链接
            _str = parseUrlLink(_str);

            // 高亮@用户
            if(to_info && to_info.length > 0) {
                _str = highLightAtUser(_str, to_info);
            }

            // 高亮股票
            if(stock_info && stock_info.length > 0) {
                _str = highLight(_str, stock_info);
            }
            let json = this.faceList || [];
            let pattern1 = /\[.+?\]/g;
            let pattern2 = /\[.+?\]/;
            let contents = _str;

            let content = contents.match(pattern1);
            let str = contents;

            if (content && Object.keys(json).length > 0) {
                for (let i = 0; i < content.length; i++) {
                    let src = "";
                    for (let item in json) {
                        if ("[" + item + "]" === content[i]) {
                            src = `<img class="AGP_face" render="ext" src="${json[item]}" alt="${item}" title="${item}" type="face">`;

                            break;
                        }
                    }
                    if (src) {
                        str = str.replace(pattern2, src);
                    }
                }
            } else {
                return str;
            }

            return str;
        },
        /* parseUrlLink(_str) {
            if (!_str || typeof _str !== 'string') {
                return _str;
            }
            const urlPattern = /https?:\/\/[A-Za-z0-9\-._~:/?#\[\]@!$&'()*+,;=%]+/gi;
            return _str.replace(urlPattern, (url) => {
                return `<span class="p-url-link" url="${url}" data-type="url">网页链接</span>`;
            });
        }, */
        setVoteSelectFn(item, index) {
            let _this = this;
            if(item.is_voted == 'yes') {
                Dialog.confirm({
                    title: '',
                    message: '是否确定要取消？',
                    className: "jh"
                })
                .then(() => {
                    _this.setVoteSelectFnApi(item, index)
                })
                .catch(() => {
                    // on cancel
                });
            } else{
                _this.setVoteSelectFnApi(item, index)
            }
        },
        // 投票接口
        async setVoteSelectFnApi(item, index) {
            let options = this.voteInfo.option;
            let type = item.is_voted == 'yes'? 'cancel': 'vote'; // vote cancel

            let res = await userHomeApi.setVoteSelect({
                type,
                option_id: item.id,
                vote_id: this.voteInfo.id,
            })
            if(res.code == 1 && res.status != 'fail') {
                // 点击取消
                if(item.is_voted == 'yes') {
                    options[index].is_voted = 'no';
                    options[index].total_num -= 1;
                    options[index].select_num -= 1;

                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>取消成功</div>",
                        position: "bottom"
                    })
                } 
                // 点击投票
                else {
                    options[index].is_voted = 'yes'
                    options[index].total_num += 1;
                    options[index].select_num += 1;

                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>投票成功</div>",
                        position: "bottom"
                    })
                }

                for(let i=0,ilen=options.length;i<ilen;i++) {
                    if(i != index) {
                        // 点击取消
                        if(item.is_voted == 'yes') {
                            options[i].total_num += 1
                        } 
                        // 点击投票
                        else {
                            options[i].total_num -= 1
                        }
                    }
                }
                let hasChecked = false;
                for(let i=0,ilen=options.length;i<ilen;i++) {
                    if(options[i].is_voted == 'yes') {
                        hasChecked = true;
                    }
                    if(options[i].select_num == 0) {
                        options[i].proportion = '0%'
                    }
                    else {
                        options[i].proportion = Math.floor(options[i].select_num / options[i].total_num * 100) + '%'
                    }
                }
                this.$set(this.voteInfo, 'option', options)
                this.hasVoteSelect = hasChecked;
            } else if(res.status == 'fail') {
                Toast.fail(res.message)
            }
        }
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

@mixin setBottomLine($c: #c7c7c7) {
    & {
        position: relative;
    }

    &::after {
        content: " ";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid $c;
    }

    [data-dpr="1"] &:before {
        transform-origin: 0 0;
        transform: scaleY(0.5);
    }
}

@mixin setTopLine($c: #c7c7c7) {
    & {
        position: relative;
    }

    &:before {
        content: " ";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid $c;
    }

    [data-dpr="1"] &:before {
        transform-origin: 0 0;
        transform: scaleY(0.5);
    }
}

.dl_check_box {
    background: $a-white;
    height: 44px;
    line-height: 44px;
    width: 100%;
    text-align: center;
}

.dl_check_box a {
    color: #507daf;
    font-size: 16px;
}

.live_item:last-child {
    margin-bottom: 0;
    // background: transparent !important;
}

.live_item {
    background: $a-white!important;
    margin-bottom: 6px;
    //强制英文长单词换行
    word-break: break-all;
    word-wrap: break-word;
    order: 2;

    &.is_order {
        order: 1;
    }

    /* 仅自己可见 */
    .is_only_self_show {
        height: 34px;
        background-image: url("../../assets/images/icon_only_self_show@2x.png");
        background-repeat: no-repeat;
        background-size: 12px 14px;
        background-position: 12px 10px;
        text-indent: 30px;
        color: #919191;
        line-height: 34px;
        font-size: 14px;
        width: 100%;
        @include setBottomLine($a-bordr-c);
    }

    /* 仅粉丝可见 */
    .is_only_fans_show {
        height: 34px;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/only_fans_show.svg");
        background-repeat: no-repeat;
        background-size: 12px 14px;
        background-position: 12px 10px;
        text-indent: 30px;
        color: #919191;
        line-height: 34px;
        font-size: 14px;
        width: 100%;
        @include setBottomLine($a-bordr-c);
    }

    /* 仅会员可见 */
    .is_only_vip_show {
        height: 34px;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/only_fans_show.svg");
        background-repeat: no-repeat;
        background-size: 12px 14px;
        background-position: 12px 10px;
        text-indent: 30px;
        color: #919191;
        line-height: 34px;
        font-size: 14px;
        width: 100%;
        
        @include setBottomLine($a-bordr-c);
    }

    .nofans {
        height: 60px;
        border-width: 1px 0px 1px 0px;
        border-color: #EBEBEB;
        border-style: solid;
        display: flex;
        align-items: center;
        padding-left: 50px;
        color: #636363;
        font-size: 14px;
        background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/nofans_i.svg);
        background-size: 22px 22px;
        background-position: 15px center;
        background-repeat: no-repeat;
        cursor: pointer;
    }

    

    //头部样式
    .live_header {
        position: relative;
        padding: 10px 12px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .user_detail {
            display: flex;

            dt {
                width: 40px;
                height: 40px;
                border: 1px solid #e6e6e6;
                border-radius: 50%;
                margin-right: 10px;
                overflow: hidden;
                box-sizing: border-box;

                >img {
                    width: 100%;
                    height: 100%;
                }
            }

            dd {
                flex: 1;

                h4 {
                    display: flex;
                    align-items: center;
                    margin: 0 0 5px 0;

                    .user_name {
                        font-size: 15px;
                        color: $a-normal;
                        font-weight: 400;
                        height: 18px;
                        line-height: 18px;
                    }

                    .user_symbol {
                        width: 14px;
                        height: 14px;
                        margin-left: 8px;
                        line-height: 0;

                        >img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                }

                p {
                    font-size: 12px;
                    line-height: 16px;
                    color: #939393;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }

        .user_operation {
            width: 30px;
            height: 30px;
            margin-right: 3px;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-end;
            padding: 10px 10px 0 0;
            box-sizing: border-box;

            img {
                width: 14px;
                height: 2px;
                display: block;
            }
        }

        .is_top_msg {
            position: absolute;
            top: 0;
            right: 40px;
            width: 51px;
            height: 44px;
            background: url(../../assets/images/icon_top_msg@2x.png);
            background-size: 100%;
        }
    }

    .live_content_box {
        background: $a-white;
    }

    //纯文字样子
    .live_content {
        color: $a-normal;
        font-size: 16px;
        line-height: 24px;
        padding: 0px 12px 0;
        &.bind_android {
            font-size: 18px;
            line-height: 24px;

            &.small, &.litter {
                font-size: 15px;
                line-height: 20px;
    
                a font {
                    font-size: 15px !important;
                }
            }
    
            &.middle {
                font-size: 19px;
                line-height: 27px;
    
                a font {
                    font-size: 19px !important;
                }
            }
    
            &.large {
                font-size: 20px;
                line-height: 27.5px;

                a font {
                    font-size: 20px !important;
                }
            }

            &.xlarge {
                font-size: 24px;
                line-height: 33px;

                a font {
                    font-size: 24px !important;
                }
            }

            &.xxlarge {
                font-size: 28px;
                line-height: 38.5px;

                a font {
                    font-size: 28px !important;
                }
            }

            &.big {
                font-size: 21px;
                line-height: 29px;
    
                a font {
                    font-size: 11px !important;
                }
            }
        }

        &.small, &.litter {
            font-size: 13px;
            line-height: 18px;

            a font {
                font-size: 13px !important;
            }
        }

        &.middle {
            font-size: 17px;
            line-height: 25px;

            a font {
                font-size: 17px !important;
            }
        }

        &.large {
            font-size: 18px;
            line-height: 25.5px;

            a font {
                font-size: 18px !important;
            }
        }

        &.xlarge {
            font-size: 22px;
            line-height: 31.5px;

            a font {
                font-size: 22px !important;
            }
        }

        &.xxlarge {
            font-size: 26px;
            line-height: 37px;

            a font {
                font-size: 26px !important;
            }
        }

        &.big {
            font-size: 19px;
            line-height: 27px;

            a font {
                font-size: 9px !important;
            }
        }

        >div {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
        }

        a font {
            font-size: 15px !important;
        }


    }

    //图片样式
    .thumbnail {
        display: flex;
        padding: 0 11px 0;

        .img-item {
            width: 33.33%;
            padding: 3px;
            box-sizing: border-box;
            margin: 0;
        }

        >div {
            height: 111px;
            width: 111px;

            >img {
                width: 100%;
                height: 100%;
            }
        }
    }

    // 视频直播样式
    .liveCardMain {
        padding: 12px 0;
        box-sizing: border-box;
        background-color: $a-white3;
        margin-top: 10px;

        &>p {
            color: #507DAF;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            /* 137.5% */
            padding: 0 12px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;

            &>span {
                background-color: transparent;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoFollow_icon.svg");
                background-size: 10px 10px;
                background-repeat: no-repeat;
                background-position: left center;
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                color: #FE484A;
                padding-left: 14px;
                margin-left: auto;
            }
        }
    }

    .transmit_image {
        padding: 6px 6px 0;
    }

    //视频专辑样式
    .video_special {
        padding: 6px 14px 0;

        .video_cover {
            height: 198px;
            position: relative;

            >img {
                width: 100%;
                height: 100%;
            }

            .play_btn {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -23px;
                margin-left: -23px;
                width: 47px;
                height: 47px;

                >img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .video_special_detail {
            display: flex;
            box-sizing: content-box;
            height: 60px;
            justify-content: space-between;
            padding: 0 10px;
            background: #f5f6f7;

            >div {
                height: 100%;
                display: flex;
                flex-direction: column;

                >h4 {
                    height: 17px;
                    font-size: 15px;
                    color: $a-222222-F3F3F3;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-weight: 400;
                    margin: 10px 0 8px 0;
                    line-height: 17px;
                }

                >p {
                    font-size: 14px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: $a-grey-a63;
                    font-size: 13px;
                }
            }

            >dl {
                flex-shrink: 0;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                >dt {
                    width: 27px;
                    height: 22px;
                    margin: 9px 0 6px 0;

                    >img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }

                >dd {
                    font-size: 14px;
                    color: #fe696b;
                }
            }
        }
    }

    //会员消息不能看全部的样式
    .members_only {
        .members_only_free {
            padding: 6px 12px 0;
            color: $a-222222-F3F3F3;
            font-size: 16px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;

            &.bind_android {
                font-size: 18px;
                line-height: 24px;
    
                &.small, &.litter {
                    font-size: 15px;
                    line-height: 20px;
                }
        
                &.middle {
                    font-size: 19px;
                    line-height: 27px;
                }
        
                &.large {
                    font-size: 20px;
                    line-height: 27.5px;
                }

                &.xlarge {
                    font-size: 24px;
                    line-height: 33px;
                }

                &.xxlarge {
                    font-size: 28px;
                    line-height: 38.5px;
                }

                &.big {
                    font-size: 21px;
                    line-height: 29px;
                }
            }
    
            &.small, &.litter {
                font-size: 13px;
                line-height: 18px;
            }
    
            &.middle {
                font-size: 17px;
                line-height: 25px;
            }
    
            &.large {
                font-size: 18px;
                line-height: 25.5px;
            }

            &.xlarge {
                font-size: 22px;
                line-height: 31.5px;
            }

            &.xxlarge {
                font-size: 26px;
                line-height: 37px;
            }

            &.large {
                font-size: 18px;
                line-height: 25.5px;
            }

            &.xlarge {
                font-size: 22px;
                line-height: 31.5px;
            }

            &.xxlarge {
                font-size: 26px;
                line-height: 37px;
            }

            &.big {
                font-size: 19px;
                line-height: 27px;
            }
    
            .user_name {
                color: #507daf;
                margin-right: 5px;
            }

            .user_name {
                color: #507daf;
                margin-right: 5px;
            }
        }

        .transpond {
            background: $a-white;
        }

        .members_only_box {
            padding: 12px 18px 0;

            &.zf {
                background: $a-white;
            }

            .vip_nosee_company {
                height: 56px;
                display: flex;
                align-items: center;
                border-top: .5px solid $a-bordr-c;
                border-bottom: .5px solid $a-bordr-c;

                span {
                    width: 21px;
                    height: 22px;
                    background: url(https://cdncos.aigupiao.com/assets/wap/img/lock_content.png);
                    margin-right: 12px;
                    margin-left: 5.5px;
                    background-size: 99% 99%;
                    background-repeat: no-repeat;
                }

                .vip_company_info {
                    b {
                        font-size: 15px;
                        line-height: 21px;
                        color: $a-grey-a63;
                        display: block;
                        font-weight: 500;
                    }

                    P {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 21px;
                        color: #939393;
                        margin-top: 1px;
                    }
                }
            }
        }
    }

    //会员消息可看全部的样式
    .member_brief {
        font-size: 16px;
        line-height: 22px;
        padding: 6px 12px 0;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        color: $a-normal;

        &.bind_android {
            font-size: 18px;
            line-height: 24px;

            &.small, &.litter {
                font-size: 15px;
                line-height: 20px;
            }
    
            &.middle {
                font-size: 19px;
                line-height: 27px;
            }
    
            &.large {
                font-size: 20px;
                line-height: 27.5px;
            }

            &.xlarge {
                font-size: 24px;
                line-height: 33px;
            }

            &.xxlarge {
                font-size: 28px;
                line-height: 38.5px;
            }

            &.big {
                font-size: 21px;
                line-height: 29px;
            }
        }

        &.small, &.litter {
            font-size: 13px;
            line-height: 18px;
        }

        &.middle {
            font-size: 17px;
            line-height: 25px;
        }

        &.big {
            font-size: 19px;
            line-height: 27px;
        }

        .user_name {
            color: #507daf;
            margin-right: 5px;
        }
    }

    .member_pad {
        height: 6px;
        width: 100%;
    }

    .transpond {
        background: $a-white;
    }

    .member_news_box {
        padding: 0 14px;

        .member_news {
            background: #fffbef;

            .member_news_header {
                height: 37px;
                box-sizing: border-box;
                border-bottom: 1px solid #ffe7d3;

                display: flex;
                align-items: center;
                margin: 0 10px;

                >dl {
                    height: 100%;
                    display: flex;
                    align-items: center;

                    >dt {
                        width: 17px;
                        height: 17px;
                        flex-shrink: 0;

                        >img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }

                    >dd {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        margin-left: 9px;

                        >h4 {
                            color: #ff8f17;
                            font-size: 14px;
                            line-height: 22px;
                        }
                    }
                }
            }

            .member_news_content {
                color: $a-normal;
                font-size: 14px;
                line-height: 21px;
                padding: 7px 10px 0;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                overflow: hidden;

                &.bind_android {
                    font-size: 16px;
                    line-height: 23px;

                    &.small, &.litter {
                        font-size: 14px;
                        line-height: 20px;
                    }
    
                    &.middle {
                        font-size: 18px;
                        line-height: 26px;
                    }
    
                    &.large {
                        font-size: 18px;
                        line-height: 26px;
                    }

                    &.xlarge {
                        font-size: 22px;
                        line-height: 32px;
                    }

                    &.xxlarge {
                        font-size: 26px;
                        line-height: 37.5px;
                    }

                    &.big {
                        font-size: 20px;
                        line-height: 29px;
                    }
                }

                &.small, &.litter {
                    font-size: 12px;
                    line-height: 18px;
                }

                &.middle {
                    font-size: 16px;
                    line-height: 24px;
                }

                &.large {
                    font-size: 16px;
                    line-height: 24px;
                }

                &.xlarge {
                    font-size: 20px;
                    line-height: 30px;
                }

                &.xxlarge {
                    font-size: 24px;
                    line-height: 36px;
                }

                &.big {
                    font-size: 18px;
                    line-height: 27px;
                }
            }

            .member_content_pad {
                width: 100%;
                height: 9px;
                background: #fffbef;
            }
        }

        .img_box {
            .thumbnail {
                padding: 0 7px 0;
            }
        }
    }

    //尾部评论点赞样式
    .live_footer {
        width: 100%;
        height: 44px;
        box-sizing: border-box;

        &.hasBtm {
            height: 20px;
        }

        .footer_top_border {
            display: flex;
            width: 100%;
            height: 44px;
            align-items: center;
            color: #8b8b8b;

            .give_like {
                margin: 9px 0;
                flex: 1;
                text-align: center;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                span img {
                    width: 20px;
                    height: 20px;
                    margin-right: 6px;
                }
            }

            .give_comment {
                margin: 9px 0;
                flex: 1;
                text-align: center;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                span img {
                    width: 20px;
                    height: 20px;
                    margin-right: 6px;
                }
            }
        }
    }

    //专栏样式
    .special_column {
        padding: 0 14px 0;

        .special_column_title {
            font-size: 16px;
            font-weight: 500;
            color: $a-222222-F3F3F3;
            font-family: PingFangSC-Medium;
            line-height: 24px;
            margin-bottom: 6px;
            //最多两行显示
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;

            &.bind_android {
                font-size: 18px;
                line-height: 27px;

                &.small, &.litter {
                    font-size: 16px;
                    line-height: 23px;
                }
    
                &.middle {
                    font-size: 20px;
                    line-height: 30px;
                }
    
                &.large {
                    font-size: 20px;
                    line-height: 30px;
                }

                &.xlarge {
                    font-size: 24px;
                    line-height: 36px;
                }

                &.xxlarge {
                    font-size: 28px;
                    line-height: 42px;
                }

                &.big {
                    font-size: 22px;
                    line-height: 33px;
                }
            }

            &.small, &.litter {
                font-size: 14px;
                line-height: 21px;
            }

            &.middle {
                font-size: 18px;
                line-height: 28px;
            }

            &.large {
                font-size: 18px;
                line-height: 28px;
            }

            &.xlarge {
                font-size: 22px;
                line-height: 34px;
            }

            &.xxlarge {
                font-size: 26px;
                line-height: 40.5px;
            }

            &.big {
                font-size: 20px;
                line-height: 31px;
            }
        }

        .special_column_content {
            color: $a-grey-a63;
            font-size: 15px;
            line-height: 21px;
            //专栏最多4行显示
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;

            &.bind_android {
                font-size: 17px;
                line-height: 23px;

                &.small, &.litter {
                    font-size: 15px;
                    line-height: 20px;
                }
        
                &.middle {
                    font-size: 19px;
                    line-height: 26px;
                }
        
                &.large {
                    font-size: 19px;
                    line-height: 25.5px;
                }

                &.xlarge {
                    font-size: 23px;
                    line-height: 30.5px;
                }

                &.xxlarge {
                    font-size: 27px;
                    line-height: 36px;
                }

                &.big {
                    font-size: 21px;
                    line-height: 28px;
                }
            }

            &.small, &.litter {
                font-size: 13px;
                line-height: 19px;
            }

            &.middle {
                font-size: 17px;
                line-height: 24px;
            }

            &.large {
                font-size: 17px;
                line-height: 23.5px;
            }

            &.xlarge {
                font-size: 21px;
                line-height: 28.5px;
            }

            &.xxlarge {
                font-size: 25px;
                line-height: 34px;
            }

            &.big {
                font-size: 19px;
                line-height: 26px;
            }
        }
    }

    .charge_kaitong_box {
        padding: 0 14px;
        margin-top: 12px;

        .charge_kaitong {
            height: 49px;
            border-top: 1px solid #f7f7f7;
            border-bottom: 1px solid #f7f7f7;
            display: flex;
            align-items: center;
            text-indent: 59px;
            font-size: 15px;
            color: $a-grey-a63;
            background: url(https://cdncos.aigupiao.com/assets/pc/img/icon-zl-vip.png) no-repeat 23px center;
            background-size: 15px;

            .price_text {
                font-style: normal;
                color: #fe484a;
            }
        }
    }

    // 分享板块
    .transpond_plate_wrap {
        padding: 10px 14px 0;

        .transpond_plate_content {
            height: 60px;
            padding: 6px;
            background: $a-white3;
            border-radius: 10px;
            border: 1px solid rgba(245, 245, 245, 1);
            display: flex;
            box-sizing: border-box;
            box-shadow: 0px 0px 14px 0px rgba(67, 67, 67, 0.07);

            .transpond_title {
                width: 85px;
                height: 48px;
                margin-right: 10px;
                position: relative;

                .plate_stock_info {
                    height: 48px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    box-sizing: border-box;
                    text-align: center;

                    &.to_green {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_plate_down.png);
                        background-size: 100%;
                    }

                    &.to_red {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_plate_up.png);
                        background-size: 100%;
                    }

                    >span {
                        display: block;
                        color: #ffffff;

                        &:first-child {
                            font-weight: bold;
                        }
                    }
                }
            }

            .transpond_detail {
                height: 100%;

                .transpond_list {
                    height: 100%;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    .simulation{
                        color:$a-normal;
                    }

                    .plate-code {
                        color: #939393;
                        font-size: 15px;
                    }
                }

                .plate_info_right {
                    font-size: 12px;
                    color: #9f9f9f;

                    >p {
                        display: flex;
                        align-items: center;

                        >img {
                            margin-left: 5px;
                            transform: rotate(-90deg);
                            width: 8px;
                            height: 8px;
                        }
                    }
                }
            }
        }
    }

    //分享组合
    .transpond_simulation_wrap_app {
        padding: 10px 12px 0;
    }

    // 分享趣味竞猜
    .transpond_guess {
        padding: 10px 12px 0;
    }

    // 分享投票
    .transpond_vote_wrap {
        padding: 11px 14px 0;

        .transpond_vote_content {
            background: #f5f6f7;
            padding: 0 10px 3px;

            .transpond_vote_title {
                font-size: 15px;
                color: $a-normal;
                height: 42px;
                line-height: 42px;

                span {
                    margin-left: 10px;
                    color: #939393;
                }
            }

            .transpond_vote_desc {
                font-size: 12px;
                color: #939393;
                height: 20px;
                line-height: 20px;
                margin-bottom: 10px;
            }

            .transpond_vote_items {

                /* 已经做出了选择后的样式 */
                &.hasVoteSelect {

                    & > div {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: flex-start;
                        padding: 10px 5px;
                        box-sizing: border-box;
                        position: relative;
                        z-index: 1;
                        border: 0.5px solid $a-bordr-c;

                        &.bind_this {
                            border: 0.5px solid #EE817F;
                        }

                        .transpond_vote_items_title {
                            text-align: left;
                        }

                        span {

                            &:last-child {
                                width: 40px;
                                display: inline-block;
                                margin-left: 10px;
                                text-align: right;
                            }
                        }

                        

                        & > div.transpond_vote_items_btn {
                            position: absolute;
                            left: 0px;
                            top: 0;
                            bottom: 0;
                            // height: 34px;
                            background-color: #F0F0F0;
                            z-index: -1;

                            &.bind_this {
                                background-color: $a-F8D2CF-763534;
                            }
                        }
                    }
                }

                > div {
                    // height: 36px;
                    // line-height: 36px;
                    line-height: 18px;
                    padding: 10px 0;
                    background: $a-white;
                    border-radius: 2px;
                    border: 1px solid $a-bordr-c;
                    text-align: center;
                    font-size: 15px;
                    color: $a-normal;
                    margin-bottom: 9px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }

            .transpond_vote_footer {
                display: flex;
                justify-content: space-between;
                height: 34px;
                line-height: 34px;

                .close_time {
                    font-size: 12px;
                    color: #939393;
                }

                .create_user {
                    color: #939393;
                    font-size: 12px;

                    >.create_user_name {
                        color: #1d88d0;
                    }
                }
            }

            .transpond_vote_share_btn {
                width: 100%;
                height: 36px;
                margin-bottom: 10px;
                font-size: 16px;

                button {
                    width: 100%;
                    height: 36px;
                    border: 1px solid $a-bordr-c;
                    background-color: $a-white;
                    outline: none;
                    color: #fe484a;
                }
            }
        }
    }

    // 分享模拟炒股样式
    .transpond_quiz_box_wrap {
        height: 60px;
        background:  $a-white3;
        box-shadow: 0px 1px 4px 0px #E7E9EE;
        border-radius: 10px;
        border: 0.5px solid $a-bordr-c;
        padding: 6px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 12px 5px;
        margin-bottom: 5px !important;

        .quiz_left {
            display: flex;

            .quiz_bg {
                width: 85px;
                height: 48px;
                border-radius: 6px;
                margin-right: 10px;
                position: relative;
                background-size: 100%;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/mncg_bg.png");

                &.contest_bg {
                    background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/23cg.png);
                }

                &.contest_bg_zh {

                    >h1 {
                        font-size: 15px;
                        font-weight: 600;
                        color: #FFFFFF;
                        line-height: 20px;
                        margin: 6px 0 0;
                        text-align: center;
                    }

                    >h2 {
                        font-size: 12px;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 16px;
                        text-align: center;
                    }
                }
            }

            .quiz_con {
                h1 {
                    margin: 3px 0 4.5px;
                    height: 20px;
                    font-size: 14px;
                    font-weight: 500;
                    color: $a-normal;
                    line-height: 20px;

                    >i {
                        display: inline-block;
                        width: 61px;
                        height: 18px;
                        border-radius: 4px;
                        border: 1px solid #FF484B;
                        font-size: 12px;
                        font-weight: 400;
                        color: #FF484B;
                        line-height: 18px;
                        text-align: center;
                        margin-left: 7px;
                        font-style: unset;
                    }
                }

                p {
                    height: 17px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #939393;
                    line-height: 17px;
                }
            }
        }

        .quiz_right {
            cursor: pointer;
            width: 76px;
            height: 30px;
            border-radius: 15px;
            border: 1px solid #FF484A;
            text-align: center;
            line-height: 30px;
            font-size: 12px;
            font-weight: 400;
            color: #FF484A;
            display: block;

            &:hover {
                opacity: .75;
            }
        }
    }

    // 模拟炒股大赛 - 比赛版本
    .transpond_quiz_box_wrap_bs {
        margin: 10px 12px 0;
        height: auto;
        padding: 0px 8px 0 0;
        background: #F7F7F7;
        border-radius: 0;
        border: none;
        display: flex;
        box-sizing: border-box;

        .transpond_title {
            width: 68px;
            height: 68px;
            margin-right: 10px;
            position: relative;
            background-color: transparent;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/mncgds_bsbb.svg");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 68px;
        }

        .transpond_detail {
            height: 100%;
            display: flex;
            justify-content: space-between;
            flex: 1;
            overflow: hidden;
            padding-top: 10px;

            .guess_list {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                overflow: hidden;

                .guess_title {
                    color: $a-normal;
                    font-size: 14px;
                    line-height: 20px;
                    padding-right: 10px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                .guess_info {
                    font-size: 12px;
                    line-height: 17px;
                    color: #FF443D;
                    margin-top: 11px;
                }
            }

            .guess_btns {
                display: flex;
                flex-direction: column;
                height: 100%;
                justify-content: space-around;

                >div.guess_btn {
                    width: 60px;
                    height: 24px;
                    background: #FE484A;
                    border-radius: 2px;
                    color: #ffffff;
                    text-align: center;
                    font-size: 12px;
                    line-height: 24px;
                }
            }
        }
    }

    .to_green {
        color: #0ac890;
    }

    .to_red {
        color: #fe484a;
    }

    .AGP_face {
        width: 18px;
        height: 18px;
        vertical-align: sub;
    }
}

.vedio_img {
    height: 100%;

    .vedio_image {
        display: block;
        height: 100%;
        position: relative;

        >img {
            height: 100%;
            width: 100%;
        }

        p {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;

            .vedio_time {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 70px !important;
                height: 23px !important;
                background: rgba(0, 0, 0, 0.5);
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .vedio_time_icon {
                    line-height: 23px;
                    width: 14px !important;
                    height: 14px !important;
                    margin-left: 7px;
                }

                >i {
                    color: #fff;
                    font-size: 14px !important;
                    line-height: 23px !important;
                    padding-left: 10px;
                    font-style: normal;
                }
            }
        }
    }
}

.vedio_play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px !important;
    height: 30px !important;
}

//转发资讯样式
.transpond_important_news {
    background: #F5F6F7;
    padding: 0;
    margin-top: 10px;

    .news_bg {
        background: #f5f6f7;
        padding: 7px 10px;

        >p {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            font-size: 14px;
            line-height: 20px;
            color: $a-grey-a63;
        }

        .important_news_mark {
            color: #1d88d0;
        }
    }

    .transpond_ordinary_image {
        background: #f5f6f7;

        >.img_box {
            padding-top: 0;
            padding-bottom: 7px;

            .thumbnail {
                padding: 0 10px 0;
            }
        }
    }
}

//转发专栏样式
.transpond_special_column {
    margin: 0px 14px 0px 12px;
    box-sizing: border-box;
    background: #F5F6F7;
    margin-top: 10px;

    &.is_delete {
        margin: 8px 0 0;
        padding: 10px 12px;

        .transpond_special_column_delete {

        }
    }

    &.bind_share {
        margin: 10px 0 0 0;
        padding: 0;
    }

    .user_msg {
        display: flex;
        align-items: center;
        margin-bottom: 2px;

        .user_name {
            font-size: 14px;
            color: #1d88d0;
            line-height: 21px;
            margin-bottom: 0;
        }

        &>.send_time {
            color: #939393;
            font-size: 12px;
            margin-left: 5px;
        }

        .content_type {
            width: 48px;
            height: 15px;
            margin-left: 9px;

            >img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .transpond_box {
        background: #f5f6f7;

        .user_img {
            width: 60px;
            height: 60px;
            flex-shrink: 0;

            >img {
                width: 100%;
                height: 100%;
            }
        }

        .transpond_content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 8px 12px;

            .transpond_title {
                font-size: 14px;
                line-height: 22px;
                color: $a-grey-a63;
                display: -webkit-box;
                display: -moz-box;
                position: relative;

                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;

                -webkit-line-clamp: 1;
                -moz-line-clamp: 1;

                overflow: hidden;
                margin-bottom: 2px;
                font-weight: bold;
            }

            .transpond_brief {
                font-size: 14px;
                color: $a-grey-a63;
                line-height: 21px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
        }

        .transpond_ordinary_image {
            >.img_box {
                padding-top: 0;
                padding-bottom: 7px;

                .thumbnail {
                    padding: 0 8px 0;
                }
            }
        }
    }
}

.transpond_vip_box {

    //转发会员消息
    .transpond_vip {
        padding: 12px 0 0;
        // padding: 12px 14px;
        background: $a-white;

        .members_only {
            background: #f5f6f7;
            padding: 0 12px 10px;

            .members_only_free {
                background: #f5f6f7;
                padding: 6px 0 0;
                margin-bottom: 5px;
                color: $a-grey-a63;
            }

            .members_only_box.zf {
                background: #f5f6f7;
                padding: 0;
				border-top: 1px solid $a-bordr-c;
				border-bottom: 1px solid $a-bordr-c;
            }
        }

        .member_brief {
            background: #f5f6f7;
        }

        .member_pad {
            background: #f5f6f7;
        }

        .member_news_box {
            background: #f5f6f7;
            padding: 0;
        }

        .member_content_pad {
            width: 100%;
            height: 9px;
            background: #fffbef;
        }
    }
}

//转发普通消息
.transpond_ordinary {
    padding: 12px 0 0;
    background: $a-white;

    .forward-main {
        background: $a-grey-b;

        .transpond_detail {
            background: $a-white !important;
        }

        // 转发股票
        .transpond_stock_wrap {
            padding: 2px 5px 5px;
        }

        .transpond_plate_wrap {
            padding: 0 5px 5px;
        }

        .transpond_simulation_wrap_app {
            padding: 0 5px 5px;
        }

        .transpond_guess {
            padding: 0 5px 5px;
        }

        .transpond_quiz_box_wrap_bs {
            padding-top: 0;
            margin-top: 0;
            background-color: $a-white;

            .transpond_detail {
                padding-top: 10px;
            }
        }

        .transpond_vote_wrap {
            padding: 0 5px 5px;
        }

        .transpond_kline_wrap {
            padding: 0 5px 5px;

            .transpond_kline_content {
                background: $a-white;
            }
        }

        .transpond_audio_live_wrap {
            padding: 0 5px 5px;
        }

        .transpond_quiz_box_wrap_main {
            padding: 0 12px;
        }

        // 
        .transpond_quiz_box_wrap {
            margin: 0 2px;
        }

        .transpond_quiz_box_wrap_p {
            font-size: 12px;
            line-height: 20px;
            color: #939393;
            padding-bottom: 6px;
            box-sizing: border-box;
        }

        .transpond_vote_wrap {
            padding: 0 5px 5px;
        }

        // .transpond_vip_wrap {
        // }
    }

    .transpond_ordinary_content {
        font-size: 15px;
        line-height: 21px;
        color: $a-grey-a63;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        background: #f5f6f7;
        padding-bottom: 0;
        padding: 7px;

        .user_name {
            color: #1d88d0;
            font-size: 15px;
            text-indent: 10px;
        }

        .transpond_ordinary_content_text_name {
            padding: 0 12px;
            box-sizing: border-box;

            .user_name {
                margin-right: 8px;
            }

            .send_time {
                color: #939393;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
            }
        }

        .transpond_ordinary_content_text_title {
            padding: 0 12px;
            box-sizing: border-box;
            margin-top: 5px;
            color: $a-grey-a63;
            font-size: 17px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px; /* 141.176% */
            margin-bottom: 5px;
        }
        

        .transpond_ordinary_content_text {
            font-size: 14px;
            line-height: 20px;
            color: $a-grey-a63;
            padding: 0 0 0;
            overflow: hidden;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;

            a font {
                font-size: 14px !important;
            }
        }
    }

    .transpond_ordinary_live_card {
        background-color: #F7F7F7;
        padding: 12px 0;

        &>p {
            padding-left: 12px;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            &>.user_name {
                color: #507DAF;
                font-size: 14px;
                line-height: 22px;
                margin-right: 10px;
            }

            &>.send_time {
                color: #939393;
                font-size: 12px;
            }
        }

        &>.transpond_ordinary_live_card_delete_title {
            padding-left: 12px;
            box-sizing: border-box;
            color: rgb(99, 99, 99);
            line-height: 22px;
            margin-top: 5px;
            font-size: 16px;
        }

        &>.transpond_ordinary_live_card_delete_p {
            padding-left: 12px;
            box-sizing: border-box;
            color: rgb(99, 99, 99);
            line-height: 22px;
            margin-top: 5px;
            font-size: 15px;
        }
    }

    .transpond_ordinary_image {
        background: #f5f6f7;

        >.img_box {
            padding-top: 0;
            padding-bottom: 7px;

            .thumbnail {
                padding: 0 10px 0;
            }
        }
    }

    .transpond_audio_wrap {
        padding: 5px;
        background: #f5f6f7;

        >.audio_msg_box {
            padding: 0;

            >.audio_msg_content {
                background: $a-white;
            }
        }
    }

    .video_special {
        background: #f5f6f7;
    }
}

//转发和分享不支持内容
.nonsupport_box {
    padding: 12px 0;
    text-align: center;
    line-height: 22px;
    background: $a-white;

    >a {
        color: #4e7aa2;
    }
}

/* 转发投票 - 老师 - 用户 */
.icon_vote {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    padding-left: 5px;

    .icon_vote_ico {
        display: inline-flex;
        align-items: center;
        color: rgb(251, 131, 131);
        font-size: 12px;
        line-height: 21px;

        img {
            width: 12px;
            height: 12px;
            display: inline-block;
            margin-right: 5px;
        }
    }
}

.icon_img {
    display: inline-flex;
    width: 19px;
    height: 15px;
    align-items: center;
    margin-left: 3px;
    padding-top: 3px;
    vertical-align: top;

    >img {
        width: 100%;
        height: 100%;
    }
}

.icon_video {
    display: inline-flex;
    width: 19px;
    height: 15px;
    align-items: center;
    margin-left: 3px;
    padding-top: 3px;
    vertical-align: top;

    >img {
        width: 100%;
        height: 100%;
    }
}

/* 机器人诊股 */
.live_robot {
    width: 100%;
    height: auto;
    background-color: $a-white;

    .live_robot_wrap {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 12px;

        .live_robot_content {
            overflow: hidden;
            color: $a-normal;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;

            &> p {
                font-size: 15px;
                font-style: normal;
                font-weight: 400;
                line-height: 155%;

                span {
                    color: #ff8f17;
                    margin-right: 10px;
                }
            }
        }

        .live_robot_main {
            margin-top: 10px;
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: row;
            align-items: center;

            .live_robot_avatar {
                width: 40px;
                height: 40px;
                border-radius: 40px;
                margin-right: 10px;
                
                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                }
            }

            .live_robot_brief {
                border-radius: 18px 18px 18px 0px;
                padding: 0 16px 0 34px;
                height: 36px;
                line-height: 36px;
                background-color: #D17872;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/robot_content_left.svg");
                background-size: 12px auto;
                background-position: 16px center;
                background-repeat: no-repeat;

                p {
                    color: #FFF;
                    text-align: right;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 36px;
                }
            }

            .live_robot_num {
                margin-left: auto;
                font-size: 12px;
                font-weight: 400;
                text-align: right;
                color: $a-grey-a63;
            }
        }

        .live_robot_tips {
            margin-top: 12px;

            p {
                font-size: 12px;
                font-weight: 400;
                line-height: 17px;
                color: #939393;
            }
        }

        .live_robot_btn {
            display: flex;
            flex-direction: row;
            align-items: center;
            border-radius: 4px;
            overflow: hidden;
            background-color: transparent;
            margin-top: 10px;

            & > div {
                flex: 1;
                padding-left: 12px;
                box-sizing: border-box;
                font-size: 14px;
                font-weight: 400;
                line-height: 40px;
                color: #AFAFAF;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                background-color: $a-grey-b;
                height: 40px;
                border: 0.5px solid #D6D6D6;
                border-right: 0;
            }

            & > button {
                width: 115px;
                height: 40px;
                background-color: #FE484A;
                border-radius: 0 4px 4px 0;
                border: none;
                font-size: 14px;
                font-weight: 400;
                line-height: 40px;
                color: #fff;
            }
        }
    }
}


/* 附件 */
.file_wrap24_wrap {
    width: 100%;
    height: auto;
    padding: 10px 12px 0;
    box-sizing: border-box;

    .file_wrap24 {
        flex-shrink: 0;
        margin-right: 5px;
        background-color: #F6F6F6;

        .file_wrap{
            display: inline-flex;
            margin-bottom:0px;
            align-items: center;
            width: 100%;

            .file_box{
                width: 100%;
                height: 36px;
                line-height: 36px;
                display: flex;
                align-items: center;
                font-size: 13px;
                font-weight: 400;
                color: $a-grey-a63;
                padding-right: 12.15px;
                box-sizing: border-box;

                .file_box_img{
                    width: 14px;
                    height: 16.62px;
                    background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/mp3_.svg");
                    background-size: 100%;
                    margin: 0 10px 0 12px;
                }
                .pdf_img{
                    background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/pdf_.svg");
                    background-size: 100%;
                }
                .doc_img, .docx_img {
                    background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/word_.svg");
                    background-size: 100%;
                }
                .xls_img, .xlsx_img {
                    background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/xlsx_.svg");
                    background-size: 100%;
                }
                .ppt_img, .pptx_img {
                    background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/ppt_.svg");
                    background-size: 100%;
                }
                .txt_img {
                    background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/txt_.svg");
                    background-size: 100%;
                }

                .file_box_download{
                    width: 11.85px;
                    height: 15px;
                    border: none;
                    outline: none;
                    padding: 0;
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/downloadFile.svg");
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: 100%;
                }

                .file_box_view_rf { 
                    flex: 1;
                    display: inline-flex;
                    align-items: center;

                    p {
                        font-size: 14px;
                        font-weight: 400;
                        color: $a-grey-a63;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        max-width: 150px;
                    }

                    span {
                        color: #939393;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}

/* 文章底部样式 - 题材行业 复盘 - 话题之类的 */
.article_kind_box {
    width: 100%;
    height: auto;
    padding: 10px 12px;


    button {
        border-radius: 14px;
        border: 1px solid $a-bordr-e;
        padding: 0 12.5px 0 0;
        outline: none;
        background-color: transparent;
        background-repeat: no-repeat;
        color: rgb(108, 108, 108);
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;

        &.article_kind {
            padding-left: 29px;
            background-position: 4px center;
            background-size: 20px 20px;
            margin-right: 10px;
        }

        &.article_topic_card {
            padding-left: 28.5px;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveCardTopicIcon.svg");
            background-size: 16.72px auto;
            background-position: 7.11px center;
        }
    }
}

.transpond_quiz_box_wrap_bs_p {
    font-size: 12px;
    line-height: 20px;
    color: #939393;
    box-sizing: border-box;
    background-color: #f5f6f7;
    padding-top: 5px;
    padding: 5px 0 5px 12px;
}

/* footer底部 - 评论区啥的 */
.liver_comment_wrap {
    width: 100%;
    height: auto;
    background-color: $a-white;
    padding: 0 12px 10px;
    box-sizing: border-box;

    & > div {
        width: 100%;
        height: auto;
        padding: 8px 12px;
        box-sizing: border-box;
        background-color: $a-grey-b;

        .liver_comment_list {

            .liver_comment_li {
                margin-bottom: 7px;

                p {
                    color: $a-normal;
                    font-size: 13px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 18px;
                    -webkit-line-clamp: 3;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    word-wrap: break-word;

                    .liver_comment_li_name {
                        color: #507DAF;
                        font-size: 13px;
                        font-style: normal;
                        font-weight: 400;

                        i {
                            &.is_liver {
                                width: 10px;
                                height: 10px;
                                margin-left: 2px;
                                display: inline-block;
                                background-color: transparent;
                                background-image: url("https://img1-cdn-picsh.aigupiao.com/cms_image/2021-08-11/fdb1c3893e337deee0fd5bf74d4459e5=30X30.png");
                                background-size: 100%;
                                background-repeat: no-repeat;
                                background-position: center;
                            }

                            &.is_talent {
                                width: 10px;
                                height: 10px;
                                margin-left: 2px;
                                display: inline-block;
                                background-color: transparent;
                                background-image: url("https://img1-cdn-picsh.aigupiao.com/m/image_lib/2023-09-06/5bce8ec43c43ed2b302634ffbe4a9382=39X39.png");
                                background-size: 100%;
                                background-repeat: no-repeat;
                                background-position: center;
                            }
                        }
                    }
                }
            }
        }

        .liver_comment_btn {
            height: auto;
            display: flex;


            button {
                color: #939393;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                border: none;
                background-color: transparent;
                outline: none;
                padding: 0;
            }
        }
    }
}

.view_range_show {
    width: 100%;
    height: 78px;
    line-height: 50px;
    padding: 16px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F5F6F7;

    p {
        color: #939393;
        text-align: center;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            width: 82.5px;
            height: 1px;
            background-color: $a-bordr-c;
            left: -92.5px;
            top: 50%;
            transform: translateY(-50%);
        }

        &::after {
            content: "";
            position: absolute;
            width: 82.5px;
            height: 1px;
            background-color: $a-bordr-c;
            right: -92.5px;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    button {
        background-color: transparent;
        border: none;
        color: #1D88D0;
        text-align: center;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        margin-top: 10px;
        outline: none;
    }
}

</style>
<style lang='scss'>
@import "~@/assets/sass/global.scss";
.allBtn {
    color: #507DAF;
}
.AGP_face {
    width: 18px;
    height: 18px;
    vertical-align: sub;
}
a.p-a-link {
    color: #507DAF;
}
span.p-url-link {
    color: #1D88D0;
    background-image: url(https://img1-cdn-picsh.aigupiao.com/m/image_lib/2026-06-01/650de000d8fe935721650736f0721601=28X28.png);
    background-repeat: no-repeat;
    background-position: 0 center;
    background-size: 14px;
    padding-left: 18px;
    margin: 0 5px;
}
</style>